var _ = {
  accentBorderCallout1: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M -8.333 0 Z L -8.333 100', fill: 'none', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -38.333 112.5', fill: 'none', stroke: '#000000' },
    ],
  },
  accentBorderCallout2: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M -8.333 0 Z L -8.333 100', fill: 'none', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -16.667 18.75 L -46.667 112.5', fill: 'none', stroke: '#000000' },
    ],
  },
  accentBorderCallout3: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M -8.333 0 Z L -8.333 100', fill: 'none', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -16.667 18.75 L -16.667 100 L -8.333 112.963', fill: 'none', stroke: '#000000' },
    ],
  },
  accentCallout1: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M -8.333 0 Z L -8.333 100', fill: 'none', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -38.333 112.5', fill: 'none', stroke: '#000000' },
    ],
  },
  accentCallout2: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M -8.333 0 Z L -8.333 100', fill: 'none', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -16.667 18.75 L -46.667 112.5', fill: 'none', stroke: '#000000' },
    ],
  },
  accentCallout3: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M -8.333 0 Z L -8.333 100', fill: 'none', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -16.667 18.75 L -16.667 100 L -8.333 112.963', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonBackPrevious: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 50 L 87.5 12.5 L 87.5 87.5 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      { d: 'M 12.5 50 L 87.5 12.5 L 87.5 87.5 Z', fill: 'color-mix(in srgb, currentColor 60%, black)', stroke: 'none' },
      { d: 'M 12.5 50 L 87.5 12.5 L 87.5 87.5 Z', fill: 'none', stroke: '#000000' },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonBeginning: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 31.25 50 L 87.5 12.5 L 87.5 87.5 Z M 21.875 12.5 L 12.5 12.5 L 12.5 87.5 L 21.875 87.5 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 31.25 50 L 87.5 12.5 L 87.5 87.5 Z M 21.875 12.5 L 12.5 12.5 L 12.5 87.5 L 21.875 87.5 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 31.25 50 L 87.5 12.5 L 87.5 87.5 Z M 21.875 12.5 L 21.875 87.5 L 12.5 87.5 L 12.5 12.5 Z',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonBlank: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  actionButtonDocument: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 21.875 12.5 L 59.375 12.5 L 78.125 31.25 L 78.125 87.5 L 21.875 87.5 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 21.875 12.5 L 59.375 12.5 L 59.375 31.25 L 78.125 31.25 L 78.125 87.5 L 21.875 87.5 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 59.375 12.5 L 59.375 31.25 L 78.125 31.25 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
      },
      {
        d: 'M 21.875 12.5 L 59.375 12.5 L 78.125 31.25 L 78.125 87.5 L 21.875 87.5 Z M 78.125 31.25 L 59.375 31.25 L 59.375 12.5',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonEnd: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 68.75 50 L 12.5 12.5 L 12.5 87.5 Z M 78.125 12.5 L 87.5 12.5 L 87.5 87.5 L 78.125 87.5 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 68.75 50 L 12.5 12.5 L 12.5 87.5 Z M 78.125 12.5 L 87.5 12.5 L 87.5 87.5 L 78.125 87.5 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 68.75 50 L 12.5 87.5 L 12.5 12.5 Z M 78.125 12.5 L 87.5 12.5 L 87.5 87.5 L 78.125 87.5 Z',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonForwardNext: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 87.5 50 L 12.5 12.5 L 12.5 87.5 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      { d: 'M 87.5 50 L 12.5 12.5 L 12.5 87.5 Z', fill: 'color-mix(in srgb, currentColor 60%, black)', stroke: 'none' },
      { d: 'M 87.5 50 L 12.5 87.5 L 12.5 12.5 Z', fill: 'none', stroke: '#000000' },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonHelp: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 28.571428571428573 33.92857142857143 A 21.428571428571427 21.428571428571427 0 0 1 71.42857142857143 33.92857142857142 A 10.714285714285714 16.071428571428573 0 0 1 60.714285714285715 50 A 5.357142857142857 8.035714285714286 0 0 0 55.35714285714286 58.035714285714285 L 55.357142857142854 68.75 L 44.642857142857146 68.75 L 44.642857142857146 58.035714285714285 A 10.714285714285714 16.071428571428573 0 0 1 55.35714285714286 41.96428571428571 A 5.357142857142857 8.035714285714286 0 0 0 60.714285714285715 33.92857142857142 A 10.714285714285714 10.714285714285714 0 0 0 39.285714285714285 33.92857142857142 Z M 50 71.42857142857143 A 8.035714285714286 8.035714285714286 0 0 1 50 87.50000000000001 A 8.035714285714286 8.035714285714286 0 0 1 50 71.42857142857143 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 28.571428571428573 33.92857142857143 A 21.428571428571427 21.428571428571427 0 0 1 71.42857142857143 33.92857142857142 A 10.714285714285714 16.071428571428573 0 0 1 60.714285714285715 50 A 5.357142857142857 8.035714285714286 0 0 0 55.35714285714286 58.035714285714285 L 55.357142857142854 68.75 L 44.642857142857146 68.75 L 44.642857142857146 58.035714285714285 A 10.714285714285714 16.071428571428573 0 0 1 55.35714285714286 41.96428571428571 A 5.357142857142857 8.035714285714286 0 0 0 60.714285714285715 33.92857142857142 A 10.714285714285714 10.714285714285714 0 0 0 39.285714285714285 33.92857142857142 Z M 50 71.42857142857143 A 8.035714285714286 8.035714285714286 0 0 1 50 87.50000000000001 A 8.035714285714286 8.035714285714286 0 0 1 50 71.42857142857143 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 28.571428571428573 33.92857142857143 A 21.428571428571427 21.428571428571427 0 0 1 71.42857142857143 33.92857142857142 A 10.714285714285714 16.071428571428573 0 0 1 60.714285714285715 50 A 5.357142857142857 8.035714285714286 0 0 0 55.35714285714286 58.035714285714285 L 55.357142857142854 68.75 L 44.642857142857146 68.75 L 44.642857142857146 58.035714285714285 A 10.714285714285714 16.071428571428573 0 0 1 55.35714285714286 41.96428571428571 A 5.357142857142857 8.035714285714286 0 0 0 60.714285714285715 33.92857142857142 A 10.714285714285714 10.714285714285714 0 0 0 39.285714285714285 33.92857142857142 Z M 50 71.42857142857143 A 8.035714285714286 8.035714285714286 0 0 1 50 87.50000000000001 A 8.035714285714286 8.035714285714286 0 0 1 50 71.42857142857143 Z',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonHome: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 50 12.5 L 12.5 50 L 21.875 50 L 21.875 87.5 L 78.125 87.5 L 78.125 50 L 87.5 50 L 73.4375 35.9375 L 73.4375 17.1875 L 64.0625 17.1875 L 64.0625 26.5625 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 73.4375 35.9375 L 73.4375 17.1875 L 64.0625 17.1875 L 64.0625 26.5625 Z M 21.875 50 L 21.875 87.5 L 45.3125 87.5 L 45.3125 68.75 L 54.6875 68.75 L 54.6875 87.5 L 78.125 87.5 L 78.125 50 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 50 12.5 L 12.5 50 L 87.5 50 Z M 45.3125 68.75 L 54.6875 68.75 L 54.6875 87.5 L 45.3125 87.5 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 50 12.5 L 64.0625 26.5625 L 64.0625 17.1875 L 73.4375 17.1875 L 73.4375 35.9375 L 87.5 50 L 78.125 50 L 78.125 87.5 L 21.875 87.5 L 21.875 50 L 12.5 50 Z M 64.0625 26.5625 L 73.4375 35.9375 M 78.125 50 L 21.875 50 M 45.3125 87.5 L 45.3125 68.75 L 54.6875 68.75 L 54.6875 87.5',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonInformation: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 50 12.5 A 37.5 37.5 0 0 1 50.00000000000002 87.5 A 37.5 37.5 0 0 1 49.99999999999999 12.5 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 50 12.5 A 37.5 37.5 0 0 1 50.00000000000002 87.5 A 37.5 37.5 0 0 1 49.99999999999999 12.5 Z M 50 14.84375 A 7.03125 7.03125 0 0 1 50 28.90625 A 7.03125 7.03125 0 0 1 50 14.84375 M 35.9375 35.9375 L 35.9375 40.625 L 42.96875 40.625 L 42.96875 73.4375 L 35.9375 73.4375 L 35.9375 78.125 L 64.0625 78.125 L 64.0625 73.4375 L 57.03125 73.4375 L 57.03125 35.9375 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 50 14.84375 A 7.03125 7.03125 0 0 1 50 28.90625 A 7.03125 7.03125 0 0 1 50 14.84375 M 35.9375 35.9375 L 57.03125 35.9375 L 57.03125 73.4375 L 64.0625 73.4375 L 64.0625 78.125 L 35.9375 78.125 L 35.9375 73.4375 L 42.96875 73.4375 L 42.96875 40.625 L 35.9375 40.625 Z',
        fill: 'color-mix(in srgb, currentColor 60%, white)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 50 12.5 A 37.5 37.5 0 0 1 50.00000000000002 87.5 A 37.5 37.5 0 0 1 49.99999999999999 12.5 Z M 50 14.84375 A 7.03125 7.03125 0 0 1 50 28.90625 A 7.03125 7.03125 0 0 1 50 14.84375 M 35.9375 35.9375 L 57.03125 35.9375 L 57.03125 73.4375 L 64.0625 73.4375 L 64.0625 78.125 L 35.9375 78.125 L 35.9375 73.4375 L 42.96875 73.4375 L 42.96875 40.625 L 35.9375 40.625 Z',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonMovie: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 30.833333333333332 L 12.5 45.677083333333336 L 17.552083333333332 45.677083333333336 L 19.114583333333332 43.982638888888886 L 20.572916666666664 43.982638888888886 L 20.572916666666664 66.63888888888889 L 71.5625 66.63888888888889 L 71.5625 58.826388888888886 L 79.63541666666667 58.826388888888886 L 84.01041666666667 63.125 L 87.5 63.125 L 87.5 35.52083333333333 L 84.01041666666667 35.52083333333333 L 80.98958333333333 38.513888888888886 L 71.5625 38.513888888888886 L 71.5625 35.52083333333333 L 68.59375 32.39583333333333 L 19.114583333333332 32.39583333333333 L 17.552083333333332 30.833333333333332 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 12.5 30.833333333333332 L 12.5 45.677083333333336 L 17.552083333333332 45.677083333333336 L 19.114583333333332 43.982638888888886 L 20.572916666666664 43.982638888888886 L 20.572916666666664 66.63888888888889 L 71.5625 66.63888888888889 L 71.5625 58.826388888888886 L 79.63541666666667 58.826388888888886 L 84.01041666666667 63.125 L 87.5 63.125 L 87.5 35.52083333333333 L 84.01041666666667 35.52083333333333 L 80.98958333333333 38.513888888888886 L 71.5625 38.513888888888886 L 71.5625 35.52083333333333 L 68.59375 32.39583333333333 L 19.114583333333332 32.39583333333333 L 17.552083333333332 30.833333333333332 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
      },
      {
        d: 'M 12.5 30.833333333333332 L 17.552083333333332 30.833333333333332 L 19.114583333333332 32.39583333333333 L 68.59375 32.39583333333333 L 71.5625 35.52083333333333 L 71.5625 38.513888888888886 L 80.98958333333333 38.513888888888886 L 84.01041666666667 35.52083333333333 L 87.5 35.52083333333333 L 87.5 63.125 L 84.01041666666667 63.125 L 79.63541666666667 58.826388888888886 L 71.5625 58.826388888888886 L 71.5625 66.63888888888889 L 20.572916666666664 66.63888888888889 L 20.572916666666664 43.982638888888886 L 19.114583333333332 43.982638888888886 L 17.552083333333332 45.677083333333336 L 12.5 45.677083333333336 Z',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonReturn: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 87.5 31.25 L 68.75 12.5 L 50 31.25 L 59.375 31.25 L 59.375 59.375 A 9.375 9.375 0 0 1 50 68.75 L 40.625 68.75 A 9.375 9.375 0 0 1 31.25 59.375 L 31.25 31.25 L 12.5 31.25 L 12.5 59.375 A 28.125 28.125 0 0 0 40.625 87.5 L 50 87.5 A 28.125 28.125 0 0 0 78.125 59.375 L 78.125 31.25 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 87.5 31.25 L 68.75 12.5 L 50 31.25 L 59.375 31.25 L 59.375 59.375 A 9.375 9.375 0 0 1 50 68.75 L 40.625 68.75 A 9.375 9.375 0 0 1 31.25 59.375 L 31.25 31.25 L 12.5 31.25 L 12.5 59.375 A 28.125 28.125 0 0 0 40.625 87.5 L 50 87.5 A 28.125 28.125 0 0 0 78.125 59.375 L 78.125 31.25 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
      },
      {
        d: 'M 87.5 31.25 L 78.125 31.25 L 78.125 59.375 A 28.125 28.125 0 0 1 50 87.5 L 40.625 87.5 A 28.125 28.125 0 0 1 12.5 59.375 L 12.5 31.25 L 31.25 31.25 L 31.25 59.375 A 9.375 9.375 0 0 0 40.625 68.75 L 50 68.75 A 9.375 9.375 0 0 0 59.375 59.375 L 59.375 31.25 L 50 31.25 L 68.75 12.5 Z',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  actionButtonSound: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 35.9375 L 12.5 64.0625 L 35.9375 64.0625 L 59.375 87.5 L 59.375 12.5 L 35.9375 35.9375 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 12.5 35.9375 L 12.5 64.0625 L 35.9375 64.0625 L 59.375 87.5 L 59.375 12.5 L 35.9375 35.9375 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
      },
      {
        d: 'M 12.5 35.9375 L 35.9375 35.9375 L 59.375 12.5 L 59.375 87.5 L 35.9375 64.0625 L 12.5 64.0625 Z M 68.75 35.9375 L 87.5 21.875 M 68.75 50 L 87.5 50 M 68.75 64.0625 L 87.5 78.125',
        fill: 'none',
        stroke: '#000000',
      },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  arc: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 49.99999999999999 0 A 50 50 0 0 1 100 49.999999999999986', fill: 'none', stroke: '#000000' }],
  },
  bentArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 100 L 0 56.25 A 43.75 43.75 0 0 1 43.74999999999999 12.499999999999993 L 75 12.5 L 75 0 L 100 25 L 75 50 L 75 37.5 L 43.75 37.5 A 18.75 18.75 0 0 0 25 56.25 L 25 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  bentConnector2: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 100 0 L 100 100', fill: 'none', stroke: '#000000' }],
  },
  bentConnector3: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 50 0 L 50 100 L 100 100', fill: 'none', stroke: '#000000' }],
  },
  bentConnector4: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 50 0 L 50 50 L 100 50 L 100 100', fill: 'none', stroke: '#000000' }],
  },
  bentConnector5: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 50 0 L 50 50 L 50 50 L 50 100 L 100 100', fill: 'none', stroke: '#000000' }],
  },
  bentUpArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 75 L 62.5 75 L 62.5 25 L 50 25 L 75 0 L 100 25 L 87.5 25 L 87.5 100 L 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  bevel: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 12.5 12.5 L 87.5 12.5 L 87.5 87.5 L 12.5 87.5 Z', fill: '#000000', stroke: 'none' },
      {
        d: 'M 0 0 L 100 0 L 87.5 12.5 L 12.5 12.5 Z',
        fill: 'color-mix(in srgb, currentColor 80%, white)',
        stroke: 'none',
      },
      {
        d: 'M 0 100 L 12.5 87.5 L 87.5 87.5 L 100 100 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 0 0 L 12.5 12.5 L 12.5 87.5 L 0 100 Z',
        fill: 'color-mix(in srgb, currentColor 60%, white)',
        stroke: 'none',
      },
      {
        d: 'M 100 0 L 100 100 L 87.5 87.5 L 87.5 12.5 Z',
        fill: 'color-mix(in srgb, currentColor 60%, black)',
        stroke: 'none',
      },
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 12.5 L 87.5 12.5 L 87.5 87.5 L 12.5 87.5 Z M 0 0 L 12.5 12.5 M 0 100 L 12.5 87.5 M 100 0 L 87.5 12.5 M 100 100 L 87.5 87.5',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  blockArc: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50.00000000000001 A 50 50 0 0 1 100 49.999999999999986 L 75 50 A 25 25 0 0 0 25 50 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  borderCallout1: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -38.333 112.5', fill: 'none', stroke: '#000000' },
    ],
  },
  borderCallout2: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -16.667 18.75 L -46.667 112.5', fill: 'none', stroke: '#000000' },
    ],
  },
  borderCallout3: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M -8.333 18.75 L -16.667 18.75 L -16.667 100 L -8.333 112.963', fill: 'none', stroke: '#000000' },
    ],
  },
  bracePair: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 16.666 100 A 8.333 8.333 0 0 1 8.333 91.667 L 8.333 58.333 A 8.333 8.333 0 0 0 5.102490888647448e-16 50 A 8.333 8.333 0 0 0 8.333 41.667 L 8.333 8.333 A 8.333 8.333 0 0 1 16.666 -1.7763568394002505e-15 L 83.334 0 A 8.333 8.333 0 0 1 91.667 8.332999999999998 L 91.667 41.667 A 8.333 8.333 0 0 0 100 50 A 8.333 8.333 0 0 0 91.667 58.333 L 91.667 91.667 A 8.333 8.333 0 0 1 83.334 100 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 16.666 100 A 8.333 8.333 0 0 1 8.333 91.667 L 8.333 58.333 A 8.333 8.333 0 0 0 5.102490888647448e-16 50 A 8.333 8.333 0 0 0 8.333 41.667 L 8.333 8.333 A 8.333 8.333 0 0 1 16.666 -1.7763568394002505e-15 M 83.334 0 A 8.333 8.333 0 0 1 91.667 8.332999999999998 L 91.667 41.667 A 8.333 8.333 0 0 0 100 50 A 8.333 8.333 0 0 0 91.667 58.333 L 91.667 91.667 A 8.333 8.333 0 0 1 83.334 100',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  bracketPair: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100 L 16.667 100 A 16.667 16.667 0 0 1 0 83.333 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 16.667 100 A 16.667 16.667 0 0 1 0 83.333 L 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 M 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  callout1: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M -8.333 18.75 L -38.333 112.5', fill: 'none', stroke: '#000000' },
    ],
  },
  callout2: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M -8.333 18.75 L -16.667 18.75 L -46.667 112.5', fill: 'none', stroke: '#000000' },
    ],
  },
  callout3: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M -8.333 18.75 L -16.667 18.75 L -16.667 100 L -8.333 112.963', fill: 'none', stroke: '#000000' },
    ],
  },
  can: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 12.5 A 50 12.5 0 0 0 100 12.499999999999998 L 100 87.5 A 50 12.5 0 0 1 0 87.5 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 0 12.5 A 50 12.5 0 0 1 100 12.499999999999995 A 50 12.5 0 0 1 0 12.499999999999996 Z',
        fill: 'color-mix(in srgb, currentColor 60%, white)',
        stroke: 'none',
      },
      {
        d: 'M 100 12.5 A 50 12.5 0 0 1 0 12.500000000000002 A 50 12.5 0 0 1 100 12.499999999999996 L 100 87.5 A 50 12.5 0 0 1 0 87.5 L 0 12.5',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  chartPlus: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 50 0 L 50 100 M 0 50 L 100 50', fill: 'none', stroke: '#000000' },
      { d: 'M 0 0 L 0 100 L 100 100 L 100 0 Z', fill: '#000000', stroke: 'none' },
    ],
  },
  chartStar: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 100 M 0 100 L 100 0 M 50 0 L 50 100', fill: 'none', stroke: '#000000' },
      { d: 'M 0 0 L 0 100 L 100 100 L 100 0 Z', fill: '#000000', stroke: 'none' },
    ],
  },
  chartX: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 100 M 0 100 L 100 0', fill: 'none', stroke: '#000000' },
      { d: 'M 0 0 L 0 100 L 100 100 L 100 0 Z', fill: '#000000', stroke: 'none' },
    ],
  },
  chevron: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 50 0 L 100 50 L 50 100 L 0 100 L 50 50 Z', fill: '#000000', stroke: '#000000' }],
  },
  chord: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 85.35533905932738 85.35533905932738 A 50 50 0 0 1 3.806023374435661 69.1341716182545 A 50 50 0 0 1 49.99999999999999 7.105427357601002e-15 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  circularArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 6.25 50.00000000000001 A 43.75 43.75 0 0 1 92.00503607239835 37.76727975646819 L 97.94870282721459 37.767278803641936 L 87.5 49.99999999999999 L 72.94870282721459 37.767278803641936 L 78.75626944045719 37.767278803641936 A 31.25 31.25 0 0 0 18.74999910786014 49.999997902787435 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  cloud: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 9.027777777777777 33.263888888888886 A 15.631944444444443 21.273148148148145 0 0 1 30.57998957216487 9.85246862529543 A 12.344907407407407 16.82175925925926 0 0 1 47.80891412463702 6.079559020422696 A 10.104166666666666 13.761574074074073 0 0 1 63.17482489729218 3.8997359934452227 A 11.243055555555555 15.266203703703702 0 0 1 81.4699864255032 11.79662680033136 A 12.344907407407407 16.83564814814815 0 0 1 89.70950362413667 36.805045586854234 A 15.68287037037037 21.34259259259259 0 0 1 80.50683519493268 73.45235178627696 A 13.391203703703702 18.21064814814815 0 0 1 61.5295304537904 89.80375312777574 A 15.629629629629628 21.33101851851852 0 0 1 35.53836349121606 96.03429219674027 A 17.87037037037037 24.40509259259259 0 0 1 14.265888824303735 88.73812262075411 A 10.092592592592592 13.699074074074073 0 0 1 7.154178969814962 64.32542955825295 A 10.05787037037037 13.761574074074073 0 0 1 10.355981204179617 37.95132232917963 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 10.863425925925926 60.594907407407405 A 10.05787037037037 13.761574074074073 0 0 1 6.3341973784947445 59.507019673542544 M 16.037037037037035 80.78472222222221 A 10.092592592592592 13.699074074074073 0 0 1 14.058709360103522 81.29044790335425 M 38.14351851851852 90.4861111111111 A 15.629629629629628 21.33101851851852 0 0 1 35.927529327520006 86.22025847613271 M 66.72916666666666 80.44212962962962 A 15.629629629629628 21.33101851851852 0 0 1 65.64350914942649 86.19106007926317 M 79.00231481481481 53.13425925925926 A 13.391203703703702 18.21064814814815 0 0 1 87.87692721942935 70.4768770248552 M 96.75462962962962 35.541666666666664 A 12.344907407407407 16.83564814814815 0 0 1 92.62714666279902 41.3312984002895 M 88.71296296296296 12.560185185185185 A 11.243055555555555 15.266203703703702 0 0 1 89.03277422425806 16.48423239319878 M 67.31018518518518 9.148148148148147 A 11.243055555555555 15.266203703703702 0 0 1 69.59160776727714 5.445361345350392 M 51.25231481481481 10.925925925925926 A 10.104166666666666 13.761574074074073 0 0 1 52.582357388029564 7.102165159074247 M 32.407407407407405 12.018518518518517 A 15.631944444444443 21.273148148148145 0 0 1 35.32846815343311 14.263252515392796 M 9.55324074074074 36.54861111111111 A 15.631944444444443 21.273148148148145 0 0 1 8.640529037810998 32.332858776375595',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  cloudCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 9.027777777777777 33.263888888888886 A 15.631944444444443 21.273148148148145 0 0 1 30.57998957216487 9.85246862529543 A 12.344907407407407 16.82175925925926 0 0 1 47.80891412463702 6.079559020422696 A 10.104166666666666 13.761574074074073 0 0 1 63.17482489729218 3.8997359934452227 A 11.243055555555555 15.266203703703702 0 0 1 81.4699864255032 11.79662680033136 A 12.344907407407407 16.83564814814815 0 0 1 89.70950362413667 36.805045586854234 A 15.68287037037037 21.34259259259259 0 0 1 80.50683519493268 73.45235178627696 A 13.391203703703702 18.21064814814815 0 0 1 61.5295304537904 89.80375312777574 A 15.629629629629628 21.33101851851852 0 0 1 35.53836349121606 96.03429219674027 A 17.87037037037037 24.40509259259259 0 0 1 14.265888824303735 88.73812262075411 A 10.092592592592592 13.699074074074073 0 0 1 7.154178969814962 64.32542955825295 A 10.05787037037037 13.761574074074073 0 0 1 10.355981204179617 37.95132232917963 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 31.94477777777778 112.5 A 2.7777777777777777 2.7777777777777777 0 0 1 26.389222222222223 112.5 A 2.7777777777777777 2.7777777777777777 0 0 1 31.94477777777778 112.5 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 35.81090347544299 109.23490399880167 A 5.555555555555555 5.555555555555555 0 0 1 24.699792364331877 109.23490399880167 A 5.555555555555555 5.555555555555555 0 0 1 35.81090347544299 109.23490399880167 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 41.43382479714197 100.69933679796284 A 8.333333333333334 8.333333333333334 0 0 1 24.767158130475302 100.69933679796284 A 8.333333333333334 8.333333333333334 0 0 1 41.43382479714197 100.69933679796284 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 10.863425925925926 60.594907407407405 A 10.05787037037037 13.761574074074073 0 0 1 6.3341973784947445 59.507019673542544 M 16.037037037037035 80.78472222222221 A 10.092592592592592 13.699074074074073 0 0 1 14.058709360103522 81.29044790335425 M 38.14351851851852 90.4861111111111 A 15.629629629629628 21.33101851851852 0 0 1 35.927529327520006 86.22025847613271 M 66.72916666666666 80.44212962962962 A 15.629629629629628 21.33101851851852 0 0 1 65.64350914942649 86.19106007926317 M 79.00231481481481 53.13425925925926 A 13.391203703703702 18.21064814814815 0 0 1 87.87692721942935 70.4768770248552 M 96.75462962962962 35.541666666666664 A 12.344907407407407 16.83564814814815 0 0 1 92.62714666279902 41.3312984002895 M 88.71296296296296 12.560185185185185 A 11.243055555555555 15.266203703703702 0 0 1 89.03277422425806 16.48423239319878 M 67.31018518518518 9.148148148148147 A 11.243055555555555 15.266203703703702 0 0 1 69.59160776727714 5.445361345350392 M 51.25231481481481 10.925925925925926 A 10.104166666666666 13.761574074074073 0 0 1 52.582357388029564 7.102165159074247 M 32.407407407407405 12.018518518518517 A 15.631944444444443 21.273148148148145 0 0 1 35.32846815343311 14.263252515392796 M 9.55324074074074 36.54861111111111 A 15.631944444444443 21.273148148148145 0 0 1 8.640529037810998 32.332858776375595',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  corner: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 50 0 L 50 50 L 100 50 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  cornerTabs: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 7.0710678118654755 0 L 0 7.0710678118654755 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M 0 92.92893218813452 L 7.0710678118654755 100 L 0 100 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M 92.92893218813452 0 L 100 0 L 100 7.0710678118654755 Z', fill: '#000000', stroke: '#000000' },
      { d: 'M 100 92.92893218813452 L 100 100 L 92.92893218813452 100 Z', fill: '#000000', stroke: '#000000' },
    ],
  },
  cube: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 25 L 75 25 L 75 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M 75 25 L 100 0 L 100 75 L 75 100 Z', fill: 'color-mix(in srgb, currentColor 80%, black)', stroke: 'none' },
      { d: 'M 0 25 L 25 0 L 100 0 L 75 25 Z', fill: 'color-mix(in srgb, currentColor 80%, white)', stroke: 'none' },
      {
        d: 'M 0 25 L 25 0 L 100 0 L 100 75 L 75 100 L 0 100 Z M 0 25 L 75 25 L 100 0 M 75 25 L 75 100',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  curvedConnector2: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 C 50 0 100 50 100 100', fill: 'none', stroke: '#000000' }],
  },
  curvedConnector3: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 C 25 0 50 25 50 50 C 50 75 75 100 100 100', fill: 'none', stroke: '#000000' }],
  },
  curvedConnector4: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 C 25 0 50 12.5 50 25 C 50 37.5 62.5 50 75 50 C 87.5 50 100 75 100 100',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  curvedConnector5: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 C 25 0 50 12.5 50 25 C 50 37.5 50 50 50 50 C 50 50 50 62.5 50 75 C 50 87.5 75 100 100 100',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  curvedDownArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 75 100 L 49.00768239224544 75 L 61.50768239224544 75 A 31.25 100 0 0 0 37.416898858120966 38.6950051637524 L 56.25 0 A 31.25 100 0 0 1 80.34078353412448 36.304994836247616 L 99.00768239224544 75 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 43.75 8.348486100883193 A 31.25 100 0 0 0 16.722972521631938 107.43120402663949 L 0 100 A 31.25 100 0 0 1 35.47297252163195 0.9172820742437011 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 43.75 8.348486100883193 A 31.25 100 0 0 0 16.722972521631938 107.43120402663949 L 0 100 A 31.25 100 0 0 1 31.249999999999993 -1.4210854715202004e-14 L 56.25 0 A 31.25 100 0 0 1 80.34078353412448 36.304994836247616 L 99.00768239224544 75 L 75 100 L 49.00768239224544 75 L 61.50768239224544 75 A 31.25 100 0 0 0 37.416898858120966 38.6950051637524',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  curvedLeftArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 75 L 25 49.00768239224544 L 25 61.50768239224544 A 100 31.25 0 0 0 60.38771276200397 41.63987137975289 A 100 31.25 0 0 1 25.00000000000007 69.9536274355093 L 25 99.00768239224544 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 100 56.25 A 100 31.25 0 0 0 6.123233995736766e-15 25 L 0 0 A 100 31.25 0 0 1 100.00000000000001 31.249999999999993 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 100 56.25 A 100 31.25 0 0 0 6.123233995736766e-15 25 L 0 0 A 100 31.25 0 0 1 100.00000000000001 31.249999999999993 L 100 56.25 A 100 31.25 0 0 1 63.69500516375231 80.34078353412448 L 25 99.00768239224544 L 0 75 L 25 49.00768239224544 L 25 61.50768239224544 A 100 31.25 0 0 0 60.38771276200397 41.63987137975289',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  curvedRightArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 31.25 A 100 31.25 0 0 0 36.30499483624771 55.34078353412449 L 75 49.00768239224544 L 100 75 L 75 99.00768239224544 L 75 86.50768239224544 A 100 31.25 0 0 1 38.695005163752285 62.41689885812095 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 100 25 A 100 31.25 0 0 0 0.9172820742437295 52.02702747836806 A 100 31.25 0 0 1 100 16.55405495673611 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 0 31.25 A 100 31.25 0 0 0 36.30499483624771 55.34078353412449 L 75 49.00768239224544 L 100 75 L 75 99.00768239224544 L 75 86.50768239224544 A 100 31.25 0 0 1 38.695005163752285 62.41689885812095 L 0 31.25 A 100 31.25 0 0 1 99.99999999999999 -3.552713678800501e-15 L 100 25 A 100 31.25 0 0 0 0.9172820742437295 52.02702747836806',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  curvedUpArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 75 0 L 99.00768239224544 25 L 86.50768239224544 25 A 31.25 100 0 0 1 58.19392633648901 60.38771276200398 A 31.25 100 0 0 0 78.06173734898155 25 L 49.00768239224544 25 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 31.25 100 A 31.25 100 0 0 1 -3.552713678800501e-15 1.2246467991473532e-14 L 25 0 A 31.25 100 0 0 0 56.25 99.99999999999999 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 43.75 91.65151389911681 A 31.25 100 0 0 0 63.61781101249255 56.26380113711283 L 49.00768239224544 25 L 75 0 L 99.00768239224544 25 L 86.50768239224544 25 A 31.25 100 0 0 1 62.41689885812095 61.304994836247694 L 31.25 100 A 31.25 100 0 0 1 -3.552713678800501e-15 1.2246467991473532e-14 L 25 0 A 31.25 100 0 0 0 56.25 99.99999999999999',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  decagon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 9.54915028125263 19.09836593122781 L 34.54915028125263 0.00010576881489043899 L 65.45084971874738 0.00010576881489043899 L 90.45084971874738 19.09836593122781 L 100 50 L 90.45084971874738 80.90163406877218 L 65.45084971874738 99.99989423118511 L 34.54915028125263 99.99989423118511 L 9.54915028125263 80.90163406877218 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  diagStripe: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 50 L 50 0 L 100 0 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  diamond: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 50 L 50 0 L 100 50 L 50 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  dodecagon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 36.601851851851855 L 13.398148148148149 13.398148148148149 L 36.601851851851855 0 L 63.398148148148145 0 L 86.60185185185185 13.398148148148149 L 100 36.601851851851855 L 100 63.398148148148145 L 86.60185185185185 86.60185185185185 L 63.398148148148145 100 L 36.601851851851855 100 L 13.398148148148149 86.60185185185185 L 0 63.398148148148145 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  donut: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z M 25 50 A 25 25 0 0 0 50 75 A 25 25 0 0 0 75 50 A 25 25 0 0 0 50 25 A 25 25 0 0 0 25.000000000000007 50 Z',
        fill: '#000000',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
  },
  doubleWave: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 6.25 C 16.666666666666668 -14.583333333333332 33.333333333333336 27.083333333333332 50 6.25 C 66.66666666666667 -14.583333333333332 83.33333333333334 27.083333333333332 100 6.25 L 100 93.75 C 83.33333333333334 114.58333333333333 66.66666666666667 72.91666666666667 50 93.75 C 33.333333333333336 114.58333333333333 16.666666666666668 72.91666666666667 0 93.75 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  downArrow: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 50 L 25 50 L 25 0 L 75 0 L 75 50 L 100 50 L 50 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  downArrowCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 64.977 L 62.5 64.977 L 62.5 75 L 75 75 L 50 100 L 25 75 L 37.5 75 L 37.5 64.977 L 0 64.977 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  ellipse: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  ellipseRibbon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 Q 18.75 9.375 37.5 11.71875 L 25 21.875 Q 50 28.125 75 21.875 L 62.5 11.71875 Q 81.25 9.375 100 0 L 87.5 42.96875 L 100 75 Q 87.5 81.25 75 84.375 L 75 96.875 Q 50 103.125 25 96.875 L 25 84.375 Q 12.5 81.25 0 75 L 12.5 42.96875 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 37.5 24.21875 L 37.5 11.71875 L 25 21.875 Q 50 28.125 75 21.875 L 62.5 11.71875 L 62.5 24.21875 Q 50 25.78125 37.5 24.21875 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 0 0 Q 18.75 9.375 37.5 11.71875 L 25 21.875 Q 50 28.125 75 21.875 L 62.5 11.71875 Q 81.25 9.375 100 0 L 87.5 42.96875 L 100 75 Q 87.5 81.25 75 84.375 L 75 96.875 Q 50 103.125 25 96.875 L 25 84.375 Q 12.5 81.25 0 75 L 12.5 42.96875 Z M 25 84.375 L 25 21.875 M 75 21.875 L 75 84.375 M 37.5 11.71875 L 37.5 24.21875 M 62.5 24.21875 L 62.5 11.71875',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  ellipseRibbon2: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 100 Q 18.75 90.625 37.5 88.28125 L 25 78.125 Q 50 71.875 75 78.125 L 62.5 88.28125 Q 81.25 90.625 100 100 L 87.5 57.03125 L 100 25 Q 87.5 18.75 75 15.625 L 75 3.125 Q 50 -3.125 25 3.125 L 25 15.625 Q 12.5 18.75 0 25 L 12.5 57.03125 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 37.5 75.78125 L 37.5 88.28125 L 25 78.125 Q 50 71.875 75 78.125 L 62.5 88.28125 L 62.5 75.78125 Q 50 74.21875 37.5 75.78125 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 0 100 L 12.5 57.03125 L 0 25 Q 12.5 18.75 25 15.625 L 25 3.125 Q 50 -3.125 75 3.125 L 75 15.625 Q 87.5 18.75 100 25 L 87.5 57.03125 L 100 100 Q 81.25 90.625 62.5 88.28125 L 75 78.125 Q 50 71.875 25 78.125 L 37.5 88.28125 Q 18.75 90.625 0 100 Z M 25 78.125 L 25 15.625 M 75 15.625 L 75 78.125 M 37.5 75.78125 L 37.5 88.28125 M 62.5 88.28125 L 62.5 75.78125',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  flowChartAlternateProcess: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 A 0 0 0 0 1 0 0 L 100 0 A 0 0 0 0 1 100 0 L 100 100 A 0 0 0 0 1 100 100 L 0 100 A 0 0 0 0 1 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  flowChartCollate: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 100 0 L 50 50 L 100 100 L 0 100 L 50 50 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartConnector: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  flowChartDecision: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 50 L 50 0 L 100 50 L 50 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartDelay: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 50 0 A 50 50 0 0 1 50.00000000000002 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartDisplay: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 16.666666666666668 0 L 83.33333333333334 0 A 16.666666666666668 50 0 0 1 83.33333333333334 100 L 16.666666666666668 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  flowChartDocument: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 80.19444444444444 C 50 80.19444444444444 50 110.75 0 93.38888888888889 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  flowChartExtract: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 100 L 50 0 L 100 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartInputOutput: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 100 L 20 0 L 100 0 L 80 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartInternalStorage: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M 12.5 0 L 12.5 100 M 0 12.5 L 100 12.5', fill: 'none', stroke: '#000000' },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  flowChartMagneticDisk: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 16.666666666666668 A 50 16.666666666666668 0 0 1 100 16.66666666666666 L 100 83.33333333333334 A 50 16.666666666666668 0 0 1 0 83.33333333333334 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 100 16.666666666666668 A 50 16.666666666666668 0 0 1 0 16.66666666666667',
        fill: 'none',
        stroke: '#000000',
      },
      {
        d: 'M 0 16.666666666666668 A 50 16.666666666666668 0 0 1 100 16.66666666666666 L 100 83.33333333333334 A 50 16.666666666666668 0 0 1 0 83.33333333333334 Z',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  flowChartMagneticDrum: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 16.666666666666668 0 L 83.33333333333334 0 A 16.666666666666668 50 0 0 1 83.33333333333334 100 L 16.666666666666668 100 A 16.666666666666668 50 0 0 1 16.666666666666664 0 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 83.33333333333334 100 A 16.666666666666668 50 0 0 1 83.33333333333334 0',
        fill: 'none',
        stroke: '#000000',
      },
      {
        d: 'M 16.666666666666668 0 L 83.33333333333334 0 A 16.666666666666668 50 0 0 1 83.33333333333334 100 L 16.666666666666668 100 A 16.666666666666668 50 0 0 1 16.666666666666664 0 Z',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  flowChartMagneticTape: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 50 100 A 50 50 0 0 1 0 50.00000000000001 A 50 50 0 0 1 49.99999999999999 0 A 50 50 0 0 1 100 49.999999999999986 A 50 50 0 0 1 85.35533905932738 85.35533905932735 L 100 85.35533905932738 L 100 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  flowChartManualInput: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 20 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartManualOperation: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 100 0 L 80 100 L 20 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartMerge: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 100 0 L 50 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartMultidocument: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 96.21296296296296 C 43.04629629629629 108.99074074074073 43.04629629629629 83.43518518518518 86.08796296296296 83.43518518518518 L 86.08796296296296 17.01388888888889 L 0 17.01388888888889 Z M 7.092592592592593 17.01388888888889 L 7.092592592592593 8.402777777777777 L 92.59259259259258 8.402777777777777 L 92.59259259259258 75.24074074074073 C 89.34259259259258 75.24074074074073 86.08796296296296 75.7037037037037 86.08796296296296 75.7037037037037 L 86.08796296296296 17.01388888888889 Z M 13.759259259259258 8.402777777777777 L 13.759259259259258 0 L 100 0 L 100 66.62962962962962 C 96.29629629629629 66.62962962962962 92.59259259259258 66.97685185185185 92.59259259259258 66.97685185185185 L 92.59259259259258 8.402777777777777 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 0 17.01388888888889 L 86.08796296296296 17.01388888888889 L 86.08796296296296 83.43518518518518 C 43.04629629629629 83.43518518518518 43.04629629629629 108.99074074074073 0 96.21296296296296 Z M 7.092592592592593 17.01388888888889 L 7.092592592592593 8.402777777777777 L 92.59259259259258 8.402777777777777 L 92.59259259259258 75.24074074074073 C 89.34259259259258 75.24074074074073 86.08796296296296 75.7037037037037 86.08796296296296 75.7037037037037 M 13.759259259259258 8.402777777777777 L 13.759259259259258 0 L 100 0 L 100 66.62962962962962 C 96.29629629629629 66.62962962962962 92.59259259259258 66.97685185185185 92.59259259259258 66.97685185185185',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  flowChartOfflineStorage: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 50 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M 40 80 L 60 80', fill: 'none', stroke: '#000000' },
      { d: 'M 0 0 L 100 0 L 50 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  flowChartOffpageConnector: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 100 0 L 100 80 L 50 100 L 0 80 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartOnlineStorage: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 16.666666666666668 0 L 100 0 A 16.666666666666668 50 0 0 0 100 100 L 16.666666666666668 100 A 16.666666666666668 50 0 0 1 16.666666666666664 0 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  flowChartOr: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z',
        fill: '#000000',
        stroke: 'none',
      },
      { d: 'M 50 0 L 50 100 M 0 50 L 100 50', fill: 'none', stroke: '#000000' },
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  flowChartPredefinedProcess: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M 12.5 0 L 12.5 100 M 87.5 0 L 87.5 100', fill: 'none', stroke: '#000000' },
      { d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  flowChartPreparation: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 50 L 20 0 L 80 0 L 100 50 L 80 100 L 20 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartProcess: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartPunchedCard: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 20 L 20 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  flowChartPunchedTape: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 10 A 25 10 0 0 0 50 9.999999999999998 A 25 10 0 0 1 100 9.999999999999995 L 100 90 A 25 10 0 0 0 50 90 A 25 10 0 0 1 0 90 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  flowChartSort: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 50 L 50 0 L 100 50 L 50 100 Z', fill: '#000000', stroke: 'none' },
      { d: 'M 0 50 L 100 50', fill: 'none', stroke: '#000000' },
      { d: 'M 0 50 L 50 0 L 100 50 L 50 100 Z', fill: 'none', stroke: '#000000' },
    ],
  },
  flowChartSummingJunction: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 14.644660940672622 14.64466094067263 L 85.35533905932738 85.35533905932738 M 85.35533905932738 14.64466094067263 L 14.644660940672622 85.35533905932738',
        fill: 'none',
        stroke: '#000000',
      },
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  flowChartTerminator: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 16.087962962962962 0 L 83.91203703703704 0 A 16.087962962962962 50 0 0 1 83.91203703703704 100 L 16.087962962962962 100 A 16.087962962962962 50 0 0 1 16.08796296296296 0 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  foldedCorner: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 0 L 100 0 L 100 83.333 L 83.333 100 L 0 100 Z', fill: '#000000', stroke: 'none' },
      {
        d: 'M 83.333 100 L 86.6664 86.6664 L 100 83.333 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 83.333 100 L 86.6664 86.6664 L 100 83.333 L 83.333 100 L 0 100 L 0 0 L 100 0 L 100 83.333',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  frame: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z M 12.5 12.5 L 12.5 87.5 L 87.5 87.5 L 87.5 12.5 Z',
        fill: '#000000',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
  },
  funnel: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0.4865947579902823 28.47932110261916 A 50 25 0 0 1 50.363602241574895 1.7268853347203788 A 50 25 0 0 1 100.24060972515952 28.47932110261915 L 62.37835131050243 94.61983027565479 A 12.5 6.25 0 0 1 37.43984756871012 94.61983027565479 Z M 5 25 A 45 20 0 0 0 95 24.999999999999996 A 45 20 0 0 0 5 24.999999999999993 Z',
        fill: '#000000',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
  },
  gear6: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 74.82470053891974 25.327459734495154 L 89.57808159568633 20.881065308239084 L 95.0067779720481 30.283843250962747 L 83.77939691528152 40.83744882470668 A 35 35 0 0 1 83.77939691528152 59.16255117529331 L 95.0067779720481 69.71615674903725 L 89.57808159568633 79.11893469176091 L 74.82470053891974 74.67254026550485 A 35 35 0 0 1 58.954696376361774 83.83509144079817 L 55.42869637636177 98.83509144079817 L 44.57130362363823 98.83509144079817 L 41.045303623638226 83.83509144079817 A 35 35 0 0 1 25.175299461080265 74.67254026550485 L 10.421918404313672 79.11893469176091 L 4.9932220279519015 69.71615674903725 L 16.220603084718476 59.16255117529332 A 35 35 0 0 1 16.22060308471847 40.837448824706684 L 4.9932220279519015 30.283843250962747 L 10.421918404313672 20.881065308239084 L 25.175299461080257 25.327459734495154 A 35 35 0 0 1 41.04530362363821 16.16490855920184 L 44.57130362363823 1.1649085592018338 L 55.42869637636177 1.1649085592018338 L 58.954696376361774 16.164908559201834 A 35 35 0 0 1 74.82470053891973 25.327459734495143 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  gear9: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 70.98043216644243 15.943848336764354 L 78.75884461652657 9.416638461451942 L 84.97288812699333 14.630840079204173 L 79.89554838334669 23.424519066271323 A 40 40 0 0 1 87.96281579807138 37.3974361068193 L 98.11703506542025 37.397170398710514 L 99.52564437161423 45.38579074787268 L 89.98370857871895 48.85848859310251 A 40 40 0 0 1 87.18197600808145 64.74790358438975 L 94.96073004592583 71.27470637126171 L 90.90480119853021 78.2997812068352 L 81.36304716068582 74.82658399370717 A 40 40 0 0 1 69.00327641227653 85.19766307013315 L 70.76679975508767 95.19757079067537 L 63.14414693842693 97.97198952208531 L 58.06726741472468 89.17804482690939 A 40 40 0 0 1 41.93273258527532 89.17804482690939 L 36.85585306157307 97.97198952208531 L 29.233200244912325 95.19757079067537 L 30.996723587723466 85.19766307013313 A 40 40 0 0 1 18.636952839314183 74.82658399370717 L 9.095198801469792 78.2997812068352 L 5.039269954074172 71.27470637126171 L 12.818023991918551 64.74790358438975 A 40 40 0 0 1 10.016291421281053 48.85848859310253 L 0.4743556283857657 45.38579074787268 L 1.8829649345797463 37.397170398710514 L 12.037184201928625 37.39743610681929 A 40 40 0 0 1 20.104451616653293 23.42451906627133 L 15.027111873006675 14.630840079204173 L 21.241155383473426 9.416638461451942 L 29.019567833557574 15.943848336764354 A 40 40 0 0 1 44.18107115260436 10.425512421903086 L 45.944071152604366 0.42551242190308614 L 54.055928847395634 0.42551242190308614 L 55.81892884739563 10.425512421903086 A 40 40 0 0 1 70.98043216644243 15.943848336764354 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  halfFrame: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 100 0 L 66.667 33.333 L 33.333 33.333 L 33.333 66.667 L 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  heart: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 50 25 C 70.83333333333333 -33.333333333333336 152.08333333333331 25 50 100 C -52.08333333333333 25 29.166666666666668 -33.333333333333336 50 25 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  heptagon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M -0.0002599799999956076 64.3106646 L 9.903066619999997 19.806308549999997 L 50 0 L 90.09693338 19.806308549999997 L 100.00025998 64.3106646 L 72.25196968 100.00052685 L 27.74803032 100.00052685 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  hexagon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 25 0.00002331250544074237 L 75 0.00002331250544074237 L 100 50 L 75 99.99997668749455 L 25 99.99997668749455 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  homePlate: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 50 0 L 100 50 L 50 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  horizontalScroll: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 100 6.25 A 6.25 6.25 0 0 1 93.75 12.5 L 93.75 6.25 A 3.125 3.125 0 0 1 87.5 6.25 L 87.5 12.5 L 6.25 12.5 A 6.25 6.25 0 0 0 8.881784197001252e-16 18.75 L 0 93.75 A 6.25 6.25 0 0 0 12.5 93.75 L 12.5 87.5 L 93.75 87.5 A 6.25 6.25 0 0 0 100 81.25 Z M 6.25 25 A 6.25 6.25 0 0 0 12.5 18.75 A 3.125 3.125 0 0 0 6.25 18.75 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 6.25 25 A 6.25 6.25 0 0 0 12.5 18.75 A 3.125 3.125 0 0 0 6.25 18.75 Z M 93.75 12.5 A 6.25 6.25 0 0 0 98.16941738241593 1.8305826175840787 A 6.25 6.25 0 0 0 87.5 6.249999999999999 A 3.125 3.125 0 0 0 93.75 6.249999999999999 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 0 18.75 A 6.25 6.25 0 0 1 6.249999999999999 12.5 L 87.5 12.5 L 87.5 6.25 A 6.25 6.25 0 0 1 100 6.249999999999997 L 100 81.25 A 6.25 6.25 0 0 1 93.75 87.5 L 12.5 87.5 L 12.5 93.75 A 6.25 6.25 0 0 1 0 93.75 Z M 87.5 12.5 L 93.75 12.5 A 6.25 6.25 0 0 0 100 6.25 M 93.75 12.5 L 93.75 6.25 A 3.125 3.125 0 0 1 87.5 6.25 M 6.25 25 L 6.25 18.75 A 3.125 3.125 0 0 1 12.5 18.75 A 6.25 6.25 0 0 1 0 18.75 M 12.5 18.75 L 12.5 87.5',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  irregularSeal1: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 50 26.85185185185185 L 67.23148148148148 0 L 65.5324074074074 24.652777777777775 L 85.09259259259258 20.63425925925926 L 77.32407407407408 33.86574074074074 L 97.67129629629629 37.6712962962963 L 81.51388888888889 48.49537037037037 L 100 61.52777777777777 L 77.94907407407408 59.916666666666664 L 84.00462962962962 83.77314814814814 L 64.9074074074074 66.93055555555556 L 61.3287037037037 91.375 L 48.75925925925926 69.14351851851852 L 39.282407407407405 100 L 35.71759259259259 72.34722222222221 L 22.046296296296294 81.56018518518518 L 26.23611111111111 64.52314814814814 L 0.625 67.5324074074074 L 17.23148148148148 54.513888888888886 L 0 39.88425925925926 L 21.421296296296294 35.263888888888886 L 1.7129629629629628 10.625 L 33.85185185185185 29.259259259259256 L 38.666666666666664 10.625 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  irregularSeal2: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 53.06481481481481 20.10185185185185 L 68.47222222222221 0 L 67.24537037037037 26.74537037037037 L 83.36574074074073 14.685185185185185 L 75.83333333333333 30.24074074074074 L 100 30.763888888888886 L 78.63425925925925 43.52777777777778 L 84.58333333333333 52.26851851851852 L 75.83333333333333 56.99074074074074 L 87.39351851851852 72.37037037037037 L 67.77777777777777 66.43518518518518 L 69.17592592592592 80.41666666666666 L 56.388888888888886 73.77314814814814 L 53.75925925925926 87.23148148148148 L 45.7037037037037 80.41666666666666 L 40.27777777777778 91.25925925925925 L 34.84722222222222 83.91203703703704 L 22.76388888888889 100 L 22.24537037037037 84.44444444444444 L 5.9490740740740735 82.52314814814814 L 15.416666666666666 71.1574074074074 L 0 59.61574074074074 L 18.21759259259259 53.666666666666664 L 5.425925925925926 38.28703703703704 L 24.87037037037037 36.18981481481481 L 20.84259259259259 16.782407407407405 L 39.58333333333333 29.546296296296294 L 45.00925925925926 8.73611111111111 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  leftArrow: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 50 L 50 0 L 50 25 L 100 25 L 100 75 L 50 75 L 50 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  leftArrowCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 25 25 L 25 37.5 L 35.022999999999996 37.5 L 35.022999999999996 0 L 100 0 L 100 100 L 35.022999999999996 100 L 35.022999999999996 62.5 L 25 62.5 L 25 75 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  leftBrace: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 100 100 A 50 8.333 0 0 1 50 91.667 L 50 58.333 A 50 8.333 0 0 0 3.061616997868383e-15 50 A 50 8.333 0 0 0 50 41.667 L 50 8.333 A 50 8.333 0 0 1 99.99999999999999 -1.7763568394002505e-15 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 100 100 A 50 8.333 0 0 1 50 91.667 L 50 58.333 A 50 8.333 0 0 0 3.061616997868383e-15 50 A 50 8.333 0 0 0 50 41.667 L 50 8.333 A 50 8.333 0 0 1 99.99999999999999 -1.7763568394002505e-15',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  leftBracket: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 100 100 A 100 8.333 0 0 1 0 91.667 L 0 8.333 A 100 8.333 0 0 1 99.99999999999999 -1.7763568394002505e-15 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 100 100 A 100 8.333 0 0 1 0 91.667 L 0 8.333 A 100 8.333 0 0 1 99.99999999999999 -1.7763568394002505e-15',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  leftCircularArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 6.25 50.00000000000001 L 18.75 50.00000000000001 A 31.25 31.25 0 0 0 78.75627033259704 62.2327190991455 L 72.94870282721459 62.232721196358064 L 87.5 50 L 97.94870282721459 62.232721196358064 L 92.00503579491598 62.232721196358064 A 43.75 43.75 0 0 1 6.249999722517629 50.00000095282626 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  leftRightArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 50 0 L 50 25 L 50 25 L 50 0 L 100 50 L 50 100 L 50 75 L 50 75 L 50 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  leftRightArrowCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 25 25 L 25 37.5 L 25.9385 37.5 L 25.9385 0 L 74.0615 0 L 74.0615 37.5 L 75 37.5 L 75 25 L 100 50 L 75 75 L 75 62.5 L 74.0615 62.5 L 74.0615 100 L 25.9385 100 L 25.9385 62.5 L 25 62.5 L 25 75 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  leftRightCircularArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 12.5 50.00000000000001 L 2.0512971727853966 37.76727880364194 L 7.9949639276016455 37.767279756468184 A 43.75 43.75 0 0 1 92.00503607239835 37.76727975646819 L 97.94870282721459 37.767278803641936 L 87.5 49.99999999999999 L 72.94870282721459 37.767278803641936 L 78.75626944045719 37.767278803641936 A 31.25 31.25 0 0 0 21.243728775263097 37.76727880364193 L 27.051297172785397 37.76727880364194 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  leftRightRibbon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 41.6665 L 46.875 0 L 46.875 16.6665 L 50 16.6665 A 3.125 4.16675 0 0 1 50 25 A 3.125 4.16675 0 0 0 50 33.3335 L 53.125 33.3335 L 53.125 16.667 L 100 58.3335 L 53.125 100 L 53.125 83.3335 L 50 83.3335 A 3.125 4.16675 0 0 1 46.875 79.16675000000001 L 46.875 66.6665 L 46.875 66.6665 L 46.875 83.333 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 53.125 20.83325 A 3.125 4.16675 0 0 1 50 25 A 3.125 4.16675 0 0 0 50 33.3335 L 53.125 33.3335 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
      },
      {
        d: 'M 0 41.6665 L 46.875 0 L 46.875 16.6665 L 50 16.6665 A 3.125 4.16675 0 0 1 50 25 A 3.125 4.16675 0 0 0 50 33.3335 L 53.125 33.3335 L 53.125 16.667 L 100 58.3335 L 53.125 100 L 53.125 83.3335 L 50 83.3335 A 3.125 4.16675 0 0 1 46.875 79.16675000000001 L 46.875 66.6665 L 46.875 66.6665 L 46.875 83.333 Z M 53.125 20.83325 L 53.125 33.3335 M 46.875 29.16675 L 46.875 66.6665',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  leftRightUpArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 75 L 25 50 L 25 62.5 L 37.5 62.5 L 37.5 25 L 25 25 L 50 0 L 75 25 L 62.5 25 L 62.5 62.5 L 75 62.5 L 75 50 L 100 75 L 75 100 L 75 87.5 L 25 87.5 L 25 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  leftUpArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 75 L 25 50 L 25 62.5 L 62.5 62.5 L 62.5 25 L 50 25 L 75 0 L 100 25 L 87.5 25 L 87.5 87.5 L 25 87.5 L 25 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  lightningBolt: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 39.22222222222222 0 L 59.53703703703703 28.148148148148145 L 51.157407407407405 31.46759259259259 L 76.74537037037037 55.58796296296296 L 68.36574074074073 59.61574074074074 L 100 100 L 46.35185185185185 69.05092592592592 L 56.58333333333333 64.75462962962962 L 23.25 44.93055555555555 L 35.19444444444444 38.80555555555555 L 0 18.00925925925926 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  line: { viewBox: '0 0 100 100', paths: [{ d: 'M 0 0 L 100 100', fill: 'none', stroke: '#000000' }] },
  lineInv: { viewBox: '0 0 100 100', paths: [{ d: 'M 0 100 L 100 0', fill: 'none', stroke: '#000000' }] },
  mathDivide: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 50 11.790000000000004 A 11.76 11.76 0 0 1 50.00000000000001 35.31 A 11.76 11.76 0 0 1 49.99999999999999 11.790000000000004 Z M 50 88.21 A 11.76 11.76 0 0 1 50 64.68999999999998 A 11.76 11.76 0 0 1 50.00000000000001 88.21 Z M 13.255000000000003 38.24 L 86.745 38.24 L 86.745 61.76 L 13.255000000000003 61.76 Z',
        fill: '#000000',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
  },
  mathEqual: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 13.255000000000003 20.599999999999998 L 86.745 20.599999999999998 L 86.745 44.12 L 13.255000000000003 44.12 Z M 13.255000000000003 55.88 L 86.745 55.88 L 86.745 79.4 L 13.255000000000003 79.4 Z',
        fill: '#000000',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
  },
  mathMinus: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 13.255000000000003 38.24 L 86.745 38.24 L 86.745 61.76 L 13.255000000000003 61.76 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  mathMultiply: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 15.701924253246204 32.3330757467538 L 32.3330757467538 15.7019242532462 L 50 33.3688485064924 L 67.66692425324621 15.7019242532462 L 84.2980757467538 32.3330757467538 L 66.63115149350759 50 L 84.2980757467538 67.66692425324621 L 67.66692425324621 84.2980757467538 L 50 66.6311514935076 L 32.3330757467538 84.2980757467538 L 15.701924253246204 67.66692425324621 L 33.36884850649241 50 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  mathNotEqual: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 13.255000000000003 20.599999999999998 L 48.185994283109636 20.599999999999998 L 55.6837811089934 0 L 77.78535154987797 8.044313771019729 L 73.21545549174309 20.599999999999998 L 86.745 20.599999999999998 L 86.745 44.12 L 64.654875581802 44.12 L 60.37458562683146 55.88 L 86.745 55.88 L 86.745 79.4 L 51.81400571689038 79.4 L 44.3162188910066 100 L 22.214648450122027 91.95568622898027 L 26.78454450825693 79.4 L 13.255000000000003 79.4 L 13.255000000000003 55.88 L 35.34512441819801 55.88 L 39.62541437316855 44.12 L 13.255000000000003 44.12 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  mathPlus: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 13.255000000000003 38.24 L 38.24 38.24 L 38.24 13.255000000000003 L 61.76 13.255000000000003 L 61.76 38.24 L 86.745 38.24 L 86.745 61.76 L 61.76 61.76 L 61.76 86.745 L 38.24 86.745 L 38.24 61.76 L 13.255000000000003 61.76 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  moon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 100 100 A 100 50 0 0 1 99.99999999999999 0 A 125 62.5 0 0 0 100 69.33752296828366 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  nonIsoscelesTrapezoid: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 100 L 25 0 L 75 0 L 100 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  noSmoking: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 50 99.99999999999997 A 50 50 0 0 1 0 49.99999999999998 Z M 77.5147233635495 64.81561670087828 A 31.25 31.25 0 0 0 35.18438329912174 22.4852766364505 Z M 22.4852766364505 35.18438329912172 A 31.25 31.25 0 0 0 64.81561670087828 77.51472336354949 Z',
        fill: '#000000',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
  },
  notchedRightArrow: {
    viewBox: '0 0 100 100',
    paths: [
      { d: 'M 0 25 L 50 25 L 50 0 L 100 50 L 50 100 L 50 75 L 0 75 L 25 50 Z', fill: '#000000', stroke: '#000000' },
    ],
  },
  octagon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 29.289 L 29.289 0 L 70.711 0 L 100 29.289 L 100 70.711 L 70.711 100 L 29.289 100 L 0 70.711 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  parallelogram: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 100 L 25 0 L 100 0 L 75 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  pentagon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0.00010576881489043899 38.19650407644447 L 50 0 L 99.99989423118511 38.19650407644447 L 80.90163406877218 99.99974592355554 L 19.09836593122782 99.99974592355554 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  pie: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 100 50 A 50 50 0 0 1 14.64466094067263 85.35533905932738 A 50 50 0 0 1 49.99999999999999 0 L 50 50 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  pieWedge: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 100 A 100 100 0 0 1 99.99999999999999 -1.4210854715202004e-14 L 100 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  plaque: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 16.667 A 16.667 16.667 0 0 0 16.667 0 L 83.333 0 A 16.667 16.667 0 0 0 100 16.666999999999998 L 100 83.333 A 16.667 16.667 0 0 0 83.333 100 L 16.667 100 A 16.667 16.667 0 0 0 1.0205594100694468e-15 83.333 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  plaqueTabs: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 7.0710678118654755 0 A 7.0710678118654755 7.0710678118654755 0 0 1 4.3297802811774667e-16 7.0710678118654755 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 0 92.92893218813452 A 7.0710678118654755 7.0710678118654755 0 0 1 7.071067811865476 100 L 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 100 0 L 100 7.0710678118654755 A 7.0710678118654755 7.0710678118654755 0 0 1 92.92893218813452 8.659560562354933e-16 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 92.92893218813452 100 A 7.0710678118654755 7.0710678118654755 0 0 1 100 92.92893218813452 L 100 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  plus: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 25 L 25 25 L 25 0 L 75 0 L 75 25 L 100 25 L 100 75 L 75 75 L 75 100 L 25 100 L 25 75 L 0 75 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  quadArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 22.5 27.5 L 22.5 38.75 L 38.75 38.75 L 38.75 22.5 L 27.5 22.5 L 50 0 L 72.5 22.5 L 61.25 22.5 L 61.25 38.75 L 77.5 38.75 L 77.5 27.5 L 100 50 L 77.5 72.5 L 77.5 61.25 L 61.25 61.25 L 61.25 77.5 L 72.5 77.5 L 50 100 L 27.5 77.5 L 38.75 77.5 L 38.75 61.25 L 22.5 61.25 L 22.5 72.5 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  quadArrowCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 18.515 31.485 L 18.515 40.7425 L 25.9385 40.7425 L 25.9385 25.9385 L 40.7425 25.9385 L 40.7425 18.515 L 31.485 18.515 L 50 0 L 68.515 18.515 L 59.2575 18.515 L 59.2575 25.9385 L 74.0615 25.9385 L 74.0615 40.7425 L 81.485 40.7425 L 81.485 31.485 L 100 50 L 81.485 68.515 L 81.485 59.2575 L 74.0615 59.2575 L 74.0615 74.0615 L 59.2575 74.0615 L 59.2575 81.485 L 68.515 81.485 L 50 100 L 31.485 81.485 L 40.7425 81.485 L 40.7425 74.0615 L 25.9385 74.0615 L 25.9385 59.2575 L 18.515 59.2575 L 18.515 68.515 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  rect: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 100 0 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  ribbon: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 34.375 0 A 3.125 4.16675 0 0 1 34.375 8.3335 L 28.125 8.3335 A 3.125 4.16675 0 0 0 28.125 16.667 L 71.875 16.667 A 3.125 4.16675 0 0 0 71.875 8.3335 L 65.625 8.3335 A 3.125 4.16675 0 0 1 65.625 0 L 100 0 L 87.5 41.6665 L 100 83.333 L 75 83.333 L 75 95.83324999999999 A 3.125 4.16675 0 0 1 71.875 100 L 28.125 100 A 3.125 4.16675 0 0 1 25 95.83324999999999 L 25 83.333 L 0 83.333 L 12.5 41.6665 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 37.5 4.16675 A 3.125 4.16675 0 0 1 34.375 8.3335 L 28.125 8.3335 A 3.125 4.16675 0 0 0 28.125 16.667 L 37.5 16.667 Z M 62.5 4.16675 A 3.125 4.16675 0 0 0 65.625 8.3335 L 71.875 8.3335 A 3.125 4.16675 0 0 1 71.875 16.667 L 62.5 16.667 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 0 0 L 34.375 0 A 3.125 4.16675 0 0 1 34.375 8.3335 L 28.125 8.3335 A 3.125 4.16675 0 0 0 28.125 16.667 L 71.875 16.667 A 3.125 4.16675 0 0 0 71.875 8.3335 L 65.625 8.3335 A 3.125 4.16675 0 0 1 65.625 0 L 100 0 L 87.5 41.6665 L 100 83.333 L 75 83.333 L 75 95.83324999999999 A 3.125 4.16675 0 0 1 71.875 100 L 28.125 100 A 3.125 4.16675 0 0 1 25 95.83324999999999 L 25 83.333 L 0 83.333 L 12.5 41.6665 Z M 37.5 4.16675 L 37.5 16.667 M 62.5 16.667 L 62.5 4.16675 M 25 83.333 L 25 12.500250000000001 M 75 12.500250000000001 L 75 83.333',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  ribbon2: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 100 L 34.375 100 A 3.125 4.16675 0 0 0 34.375 91.66649999999998 L 28.125 91.6665 A 3.125 4.16675 0 0 1 28.125 83.333 L 71.875 83.333 A 3.125 4.16675 0 0 1 71.875 91.66650000000001 L 65.625 91.6665 A 3.125 4.16675 0 0 0 65.625 100 L 100 100 L 87.5 58.3335 L 100 16.667 L 75 16.667 L 75 4.16675 A 3.125 4.16675 0 0 0 71.875 0 L 28.125 0 A 3.125 4.16675 0 0 0 25 4.166750000000001 L 25 16.667 L 0 16.667 L 12.5 58.3335 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 37.5 95.83324999999999 A 3.125 4.16675 0 0 0 34.375 91.66649999999998 L 28.125 91.6665 A 3.125 4.16675 0 0 1 28.125 83.333 L 37.5 83.333 Z M 62.5 95.83324999999999 A 3.125 4.16675 0 0 1 65.625 91.66649999999998 L 71.875 91.6665 A 3.125 4.16675 0 0 0 71.875 83.333 L 62.5 83.333 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 0 100 L 12.5 58.3335 L 0 16.667 L 25 16.667 L 25 4.16675 A 3.125 4.16675 0 0 1 28.125 -8.881784197001252e-16 L 71.875 0 A 3.125 4.16675 0 0 1 75 4.1667499999999995 L 75 16.667 L 75 16.667 L 100 16.667 L 87.5 58.3335 L 100 100 L 65.625 100 A 3.125 4.16675 0 0 1 65.625 91.66649999999998 L 71.875 91.6665 A 3.125 4.16675 0 0 0 71.875 83.333 L 28.125 83.333 A 3.125 4.16675 0 0 0 28.125 91.66650000000001 L 34.375 91.6665 A 3.125 4.16675 0 0 1 34.375 100 Z M 37.5 83.333 L 37.5 95.83324999999999 M 62.5 95.83324999999999 L 62.5 83.333 M 25 87.49975 L 25 16.667 M 75 16.667 L 75 87.49975',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  rightArrow: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 25 L 50 25 L 50 0 L 100 50 L 50 100 L 50 75 L 0 75 Z', fill: '#000000', stroke: '#000000' }],
  },
  rightArrowCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 64.977 0 L 64.977 37.5 L 75 37.5 L 75 25 L 100 50 L 75 75 L 75 62.5 L 64.977 62.5 L 64.977 100 L 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  rightBrace: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 A 50 8.333 0 0 1 50.00000000000001 8.332999999999998 L 50 41.667 A 50 8.333 0 0 0 100 50 A 50 8.333 0 0 0 50.000000000000014 58.333 L 50 91.667 A 50 8.333 0 0 1 3.061616997868383e-15 100 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 0 0 A 50 8.333 0 0 1 50.00000000000001 8.332999999999998 L 50 41.667 A 50 8.333 0 0 0 100 50 A 50 8.333 0 0 0 50.000000000000014 58.333 L 50 91.667 A 50 8.333 0 0 1 3.061616997868383e-15 100',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  rightBracket: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 A 100 8.333 0 0 1 100.00000000000001 8.332999999999998 L 100 91.667 A 100 8.333 0 0 1 6.123233995736766e-15 100 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 0 0 A 100 8.333 0 0 1 100.00000000000001 8.332999999999998 L 100 91.667 A 100 8.333 0 0 1 6.123233995736766e-15 100',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  round1Rect: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 100 L 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  round2DiagRect: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 16.667 0 L 100 0 A 0 0 0 0 1 100 0 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100 L 0 100 A 0 0 0 0 1 0 100 L 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  round2SameRect: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 16.667 0 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 100 A 0 0 0 0 1 100 100 L 0 100 A 0 0 0 0 1 0 100 L 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  roundRect: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100 L 16.667 100 A 16.667 16.667 0 0 1 0 83.333 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  rtTriangle: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 100 L 0 0 L 100 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  smileyFace: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 0 50.000000000000014 Z',
        fill: '#000000',
        stroke: 'none',
      },
      {
        d: 'M 28.77314814814815 35.0462962962963 A 5.208333333333333 5.208333333333333 0 0 1 39.18981481481482 35.0462962962963 A 5.208333333333333 5.208333333333333 0 0 1 28.77314814814815 35.0462962962963 M 60.81018518518518 35.0462962962963 A 5.208333333333333 5.208333333333333 0 0 1 71.22685185185185 35.0462962962963 A 5.208333333333333 5.208333333333333 0 0 1 60.81018518518518 35.0462962962963',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 22.89967279598138 71.80533333333332 Q 50 90.41733333333333 77.03703703703704 71.80533333333332',
        fill: 'none',
        stroke: '#000000',
      },
      {
        d: 'M 0 50 A 50 50 0 0 1 100 49.99999999999998 A 50 50 0 0 1 0 50.000000000000014 Z',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  snip1Rect: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 0 L 83.333 0 L 100 16.667 L 100 100 L 0 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  snip2DiagRect: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 83.333 0 L 100 16.667 L 100 100 L 100 100 L 16.667 100 L 0 83.333 L 0 0 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  snip2SameRect: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 16.667 0 L 83.333 0 L 100 16.667 L 100 100 L 100 100 L 0 100 L 0 100 L 0 16.667 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  snipRoundRect: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 16.667 0 L 83.333 0 L 100 16.667 L 100 100 L 0 100 L 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  squareTabs: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 7.0710678118654755 0 L 7.0710678118654755 7.0710678118654755 L 0 7.0710678118654755 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 0 92.92893218813452 L 7.0710678118654755 92.92893218813452 L 7.0710678118654755 100 L 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 92.92893218813452 0 L 100 0 L 100 7.0710678118654755 L 92.92893218813452 7.0710678118654755 Z',
        fill: '#000000',
        stroke: '#000000',
      },
      {
        d: 'M 92.92893218813452 92.92893218813452 L 100 92.92893218813452 L 100 100 L 92.92893218813452 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star10: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M -0.00007738000000045986 34.549 L 13.819211287416401 24.99952793 L 19.09811633 9.549 L 36.180085377416404 9.548565019999998 L 50 0 L 63.819914622583596 9.548565019999998 L 80.90188367 9.549 L 86.18078871258359 24.99952793 L 100.00007738 34.549 L 94.72174817999999 50 L 100.00007738 65.451 L 86.18078871258359 75.00047207 L 80.90188367 90.451 L 63.819914622583596 90.45143498 L 50 100 L 36.180085377416404 90.45143498 L 19.09811633 90.451 L 13.819211287416401 75.00047207 L -0.00007738000000045986 65.451 L 5.278251820000001 50 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star12: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 13.77778151415994 40.294285808655474 L 6.698729810778062 25 L 23.483495705504467 23.48349570550447 L 25 6.698729810778069 L 40.294285808655474 13.77778151415994 L 50 0 L 59.705714191344526 13.77778151415994 L 75 6.698729810778069 L 76.51650429449553 23.48349570550447 L 93.30127018922194 25 L 86.22221848584006 40.294285808655474 L 100 50 L 86.22221848584006 59.705714191344526 L 93.30127018922194 75 L 76.51650429449553 76.51650429449553 L 75 93.30127018922192 L 59.705714191344526 86.22221848584006 L 50 100 L 40.294285808655474 86.22221848584006 L 25 93.30127018922192 L 23.483495705504467 76.51650429449553 L 6.698729810778062 75 L 13.77778151415994 59.705714191344526 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star16: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 13.220374999999997 42.684125 L 3.8059999999999974 30.866 L 18.819875 29.166125 L 14.6445 14.6445 L 29.166125 18.819875 L 30.866 3.8059999999999974 L 42.684125 13.220374999999997 L 50 0 L 57.315875 13.220374999999997 L 69.134 3.8059999999999974 L 70.833875 18.819875 L 85.3555 14.6445 L 81.180125 29.166125 L 96.194 30.866 L 86.77962500000001 42.684125 L 100 50 L 86.77962500000001 57.315875 L 96.194 69.134 L 81.180125 70.833875 L 85.3555 85.3555 L 70.833875 81.180125 L 69.134 96.194 L 57.315875 86.77962500000001 L 50 100 L 42.684125 86.77962500000001 L 30.866 96.194 L 29.166125 81.180125 L 14.6445 85.3555 L 18.819875 70.833875 L 3.8059999999999974 69.134 L 13.220374999999997 57.315875 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star24: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 12.820999999999998 45.105125 L 1.7037086855465873 37.059047744873965 L 15.354500000000002 35.6495 L 6.698729810778062 25 L 20.249375 27.1715 L 14.644660940672622 14.64466094067263 L 27.1715 20.249375 L 25 6.698729810778069 L 35.6495 15.354500000000002 L 37.059047744873965 1.7037086855465873 L 45.105125 12.820999999999998 L 50 0 L 54.894875 12.820999999999998 L 62.940952255126035 1.7037086855465873 L 64.3505 15.354500000000002 L 75 6.698729810778069 L 72.82849999999999 20.249375 L 85.35533905932738 14.64466094067263 L 79.750625 27.1715 L 93.30127018922194 25 L 84.6455 35.6495 L 98.29629131445341 37.059047744873965 L 87.179 45.105125 L 100 50 L 87.179 54.894875 L 98.29629131445341 62.940952255126035 L 84.6455 64.3505 L 93.30127018922194 75 L 79.750625 72.82849999999999 L 85.35533905932738 85.35533905932738 L 72.82849999999999 79.750625 L 75 93.30127018922192 L 64.3505 84.6455 L 62.940952255126035 98.29629131445341 L 54.894875 87.179 L 50 100 L 45.105125 87.179 L 37.059047744873965 98.29629131445341 L 35.6495 84.6455 L 25 93.30127018922192 L 27.1715 79.750625 L 14.644660940672622 85.35533905932738 L 20.249375 72.82849999999999 L 6.698729810778062 75 L 15.354500000000002 64.3505 L 1.7037086855465873 62.940952255126035 L 12.820999999999998 54.894875 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star32: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 12.680750000000003 46.32425 L 0.9605000000000032 40.2455 L 14.11475 39.1145 L 3.8059999999999974 30.866 L 16.927999999999997 32.322500000000005 L 8.426499999999997 22.2215 L 21.012125 26.210375 L 14.644660940672622 14.64466094067263 L 26.210375 21.012125 L 22.2215 8.426499999999997 L 32.322500000000005 16.927999999999997 L 30.866 3.8059999999999974 L 39.1145 14.11475 L 40.2455 0.9605000000000032 L 46.32425 12.680750000000003 L 50 0 L 53.67575 12.680750000000003 L 59.7545 0.9605000000000032 L 60.8855 14.11475 L 69.134 3.8059999999999974 L 67.6775 16.927999999999997 L 77.77850000000001 8.426499999999997 L 73.789625 21.012125 L 85.35533905932738 14.64466094067263 L 78.987875 26.210375 L 91.5735 22.2215 L 83.072 32.322500000000005 L 96.194 30.866 L 85.88525 39.1145 L 99.0395 40.2455 L 87.31925 46.32425 L 100 50 L 87.31925 53.67575 L 99.0395 59.7545 L 85.88525 60.8855 L 96.194 69.134 L 83.072 67.6775 L 91.5735 77.77850000000001 L 78.987875 73.789625 L 85.35533905932738 85.35533905932738 L 73.789625 78.987875 L 77.77850000000001 91.5735 L 67.6775 83.072 L 69.134 96.194 L 60.8855 85.88525 L 59.7545 99.0395 L 53.67575 87.31925 L 50 100 L 46.32425 87.31925 L 40.2455 99.0395 L 39.1145 85.88525 L 30.866 96.194 L 32.322500000000005 83.072 L 22.2215 91.5735 L 26.210375 78.987875 L 14.644660940672622 85.35533905932738 L 21.012125 73.789625 L 8.426499999999997 77.77850000000001 L 16.927999999999997 67.6775 L 3.8059999999999974 69.134 L 14.11475 60.8855 L 0.9605000000000032 59.7545 L 12.680750000000003 53.67575 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star4: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 41.161165235168156 41.161165235168156 L 50 0 L 58.838834764831844 41.161165235168156 L 100 50 L 58.838834764831844 58.838834764831844 L 50 100 L 41.161165235168156 58.838834764831844 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star5: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0.00010576881489043899 38.19650407644447 L 38.19681185109177 38.196772907038735 L 50 0 L 61.80318814890823 38.196772907038735 L 99.99989423118511 38.19650407644447 L 69.09795960054346 61.80313916296127 L 80.90163406877218 99.99974592355554 L 50 76.39267586 L 19.09836593122782 99.99974592355554 L 30.90204039945654 61.80313916296127 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star6: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0.000023312505433636943 25 L 33.3330602 24.999578643550826 L 50 0 L 66.6669398 24.999578643550826 L 99.99997668749457 25 L 83.3338796 50 L 99.99997668749457 75 L 66.6669398 75.00042135644918 L 50 100 L 33.3330602 75.00042135644918 L 0.000023312505433636943 75 L 16.666120399999997 50 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star7: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M -0.0002599799999956076 64.3106646 L 15.398820088640399 44.504445983508 L 9.903066619999997 19.806308549999997 L 34.6011919420464 19.806347509263 L 50 0 L 65.3988080579536 19.806347509263 L 90.09693338 19.806308549999997 L 84.6011799113596 44.504445983508 L 100.00025998 64.3106646 L 77.7478798376276 75.302350457229 L 72.25196968 100.00052685 L 50 89.0087121 L 27.74803032 100.00052685 L 22.252120162372403 75.302350457229 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  star8: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 15.354500000000002 35.6495 L 14.644660940672622 14.64466094067263 L 35.6495 15.354500000000002 L 50 0 L 64.3505 15.354500000000002 L 85.35533905932738 14.64466094067263 L 84.6455 35.6495 L 100 50 L 84.6455 64.3505 L 85.35533905932738 85.35533905932738 L 64.3505 84.6455 L 50 100 L 35.6495 84.6455 L 14.644660940672622 85.35533905932738 L 15.354500000000002 64.3505 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  straightConnector1: { viewBox: '0 0 100 100', paths: [{ d: 'M 0 0 L 100 100', fill: 'none', stroke: '#000000' }] },
  stripedRightArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 25 L 0 25 L 0 75 L 0 75 Z M 0 25 L 0 25 L 0 75 L 0 75 Z M 15.625 25 L 50 25 L 50 0 L 100 50 L 50 100 L 50 75 L 15.625 75 Z',
        fill: '#000000',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
  },
  sun: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 100 50 L 79.82292175292969 57.175445556640625 L 79.82292175292969 42.824554443359375 Z M 85.35185185185185 14.643518518518519 L 76.16092175292968 33.986554443359374 L 66.01344555664062 23.83907824707031 Z M 50 0 L 57.175445556640625 20.177078247070312 L 42.824554443359375 20.177078247070312 Z M 14.643518518518519 14.643518518518519 L 33.986554443359374 23.83907824707031 L 23.83907824707031 33.986554443359374 Z M 0 50 L 20.177078247070312 42.824554443359375 L 20.177078247070312 57.175445556640625 Z M 14.643518518518519 85.35185185185185 L 23.83907824707031 66.01344555664062 L 33.986554443359374 76.16092175292968 Z M 50 100 L 42.824554443359375 79.82292175292969 L 57.175445556640625 79.82292175292969 Z M 85.35185185185185 85.35185185185185 L 66.01344555664062 76.16092175292968 L 76.16092175292968 66.01344555664062 Z M 25 50 A 25 25 0 0 1 75 49.99999999999999 A 25 25 0 0 1 25 50.00000000000001 Z',
        fill: '#000000',
        stroke: '#000000',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
  },
  swooshArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 100 Q 16.666666666666668 33.333333333333336 83.333 0 L 83.333 0 L 100 7.5 L 86.14982349750278 25 L 86.14982349750278 25 Q 25 33.333333333333336 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  teardrop: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 A 50 50 0 0 1 49.99999999999999 -7.105427357601002e-15 Q 75 0 100 0 Q 100 25 100 50 A 50 50 0 0 1 50 100 A 50 50 0 0 1 0 50.00000000000001 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  trapezoid: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 100 L 25 0 L 75 0 L 100 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  triangle: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 100 L 50 0 L 100 100 Z', fill: '#000000', stroke: '#000000' }],
  },
  upArrow: {
    viewBox: '0 0 100 100',
    paths: [{ d: 'M 0 50 L 50 0 L 100 50 L 75 50 L 75 100 L 25 100 L 25 50 Z', fill: '#000000', stroke: '#000000' }],
  },
  upArrowCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 35.022999999999996 L 37.5 35.022999999999996 L 37.5 25 L 25 25 L 50 0 L 75 25 L 62.5 25 L 62.5 35.022999999999996 L 100 35.022999999999996 L 100 100 L 0 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  upDownArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 50 L 50 0 L 100 50 L 75 50 L 75 50 L 100 50 L 50 100 L 0 50 L 25 50 L 25 50 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  upDownArrowCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 25.9385 L 37.5 25.9385 L 37.5 25 L 25 25 L 50 0 L 75 25 L 62.5 25 L 62.5 25.9385 L 100 25.9385 L 100 74.0615 L 62.5 74.0615 L 62.5 75 L 75 75 L 50 100 L 25 75 L 37.5 75 L 37.5 74.0615 L 0 74.0615 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  uturnArrow: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 100 L 0 43.75 A 43.75 43.75 0 0 1 43.74999999999999 -7.105427357601002e-15 L 43.75 0 A 43.75 43.75 0 0 1 87.5 43.749999999999986 L 87.5 50 L 100 50 L 75 75 L 50 50 L 62.5 50 L 62.5 43.75 A 18.75 18.75 0 0 0 43.75 25 L 43.75 25 A 18.75 18.75 0 0 0 25 43.75 L 25 100 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  verticalScroll: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 6.25 100 A 6.25 6.25 0 0 0 12.5 93.75 L 6.25 93.75 A 3.125 3.125 0 0 0 6.25 87.5 L 12.5 87.5 L 12.5 6.25 A 6.25 6.25 0 0 1 18.75 -8.881784197001252e-16 L 93.75 0 A 6.25 6.25 0 0 1 93.75 12.5 L 87.5 12.5 L 87.5 93.75 A 6.25 6.25 0 0 1 81.25 100 Z M 25 6.25 A 6.25 6.25 0 0 1 18.75 12.5 A 3.125 3.125 0 0 1 18.75 6.25 Z',
        fill: '#000000',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 25 6.25 A 6.25 6.25 0 0 1 18.75 12.5 A 3.125 3.125 0 0 1 18.75 6.25 Z M 12.5 93.75 A 6.25 6.25 0 0 1 1.8305826175840787 98.16941738241593 A 6.25 6.25 0 0 1 6.249999999999999 87.5 A 3.125 3.125 0 0 1 6.250000000000001 93.75 Z',
        fill: 'color-mix(in srgb, currentColor 80%, black)',
        stroke: 'none',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        d: 'M 12.5 87.5 L 12.5 6.25 A 6.25 6.25 0 0 1 18.75 -8.881784197001252e-16 L 93.75 0 A 6.25 6.25 0 0 1 93.75 12.5 L 87.5 12.5 L 87.5 93.75 A 6.25 6.25 0 0 1 81.25 100 L 6.25 100 A 6.25 6.25 0 0 1 6.249999999999999 87.5 Z M 18.75 0 A 6.25 6.25 0 0 1 18.750000000000004 12.5 A 3.125 3.125 0 0 1 18.750000000000004 6.25 L 25 6.25 M 87.5 12.5 L 18.75 12.5 M 6.25 87.5 A 3.125 3.125 0 0 1 6.250000000000002 93.75 L 12.5 93.75 M 6.25 100 A 6.25 6.25 0 0 0 12.5 93.75 L 12.5 87.5',
        fill: 'none',
        stroke: '#000000',
      },
    ],
  },
  wave: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 12.5 C 33.333333333333336 -29.166666666666664 66.66666666666667 54.166666666666664 100 12.5 L 100 87.5 C 66.66666666666667 129.16666666666666 33.333333333333336 45.833333333333336 0 87.5 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  wedgeEllipseCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 29.167 112.5 L 25.428460527844393 93.54583157970805 A 50 50 0 0 1 65.81115470846487 2.5657572339877106 A 50 50 0 0 1 43.53022094510429 99.57965267103867 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  wedgeRectCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 0 L 16.666666666666668 0 L 16.666666666666668 0 L 41.666666666666664 0 L 100 0 L 100 58.333333333333336 L 100 58.333333333333336 L 100 83.33333333333333 L 100 100 L 41.666666666666664 100 L 29.167 112.5 L 16.666666666666668 100 L 0 100 L 0 83.33333333333333 L 0 58.333333333333336 L 0 58.333333333333336 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
  wedgeRoundRectCallout: {
    viewBox: '0 0 100 100',
    paths: [
      {
        d: 'M 0 16.667 A 16.667 16.667 0 0 1 16.666999999999998 -3.552713678800501e-15 L 16.666666666666668 0 L 16.666666666666668 0 L 41.666666666666664 0 L 83.333 0 A 16.667 16.667 0 0 1 100 16.666999999999998 L 100 58.333333333333336 L 100 58.333333333333336 L 100 83.33333333333333 L 100 83.333 A 16.667 16.667 0 0 1 83.333 100 L 41.666666666666664 100 L 29.167 112.5 L 16.666666666666668 100 L 16.667 100 A 16.667 16.667 0 0 1 0 83.333 L 0 83.33333333333333 L 0 58.333333333333336 L 0 58.333333333333336 Z',
        fill: '#000000',
        stroke: '#000000',
      },
    ],
  },
};
var F = new Set(['leftRightArrow', 'upDownArrow']),
  X = {
    leftRightArrow: `<leftRightArrow>
    <avLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <gd name="adj1" fmla="val 50000"/>
      <gd name="adj2" fmla="val 50000"/>
    </avLst>
    <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <gd name="maxAdj2" fmla="*/ 50000 w ss"/>
      <gd name="a1" fmla="pin 0 adj1 100000"/>
      <gd name="a2" fmla="pin 0 adj2 maxAdj2"/>
      <gd name="x2" fmla="*/ ss a2 100000"/>
      <gd name="x3" fmla="+- r 0 x2"/>
      <gd name="dy" fmla="*/ h a1 200000"/>
      <gd name="y1" fmla="+- vc 0 dy"/>
      <gd name="y2" fmla="+- vc dy 0"/>
      <gd name="dx1" fmla="*/ y1 x2 hd2"/>
      <gd name="x1" fmla="+- x2 0 dx1"/>
      <gd name="x4" fmla="+- x3 dx1 0"/>
    </gdLst>
    <ahLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <ahXY gdRefY="adj1" minY="0" maxY="100000">
        <pos x="x3" y="y1"/>
      </ahXY>
      <ahXY gdRefX="adj2" minX="0" maxX="maxAdj2">
        <pos x="x2" y="t"/>
      </ahXY>
    </ahLst>
    <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <cxn ang="0">
        <pos x="r" y="vc"/>
      </cxn>
      <cxn ang="cd4">
        <pos x="x3" y="b"/>
      </cxn>
      <cxn ang="cd4">
        <pos x="x2" y="b"/>
      </cxn>
      <cxn ang="cd2">
        <pos x="l" y="vc"/>
      </cxn>
      <cxn ang="3cd4">
        <pos x="x2" y="t"/>
      </cxn>
      <cxn ang="3cd4">
        <pos x="x3" y="t"/>
      </cxn>
    </cxnLst>
    <rect l="x1" t="y1" r="x4" b="y2" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main"/>
    <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <path>
        <moveTo>
          <pt x="l" y="vc"/>
        </moveTo>
        <lnTo>
          <pt x="x2" y="t"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="y1"/>
        </lnTo>
        <lnTo>
          <pt x="x3" y="y1"/>
        </lnTo>
        <lnTo>
          <pt x="x3" y="t"/>
        </lnTo>
        <lnTo>
          <pt x="r" y="vc"/>
        </lnTo>
        <lnTo>
          <pt x="x3" y="b"/>
        </lnTo>
        <lnTo>
          <pt x="x3" y="y2"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="y2"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="b"/>
        </lnTo>
        <close/>
      </path>
    </pathLst>
  </leftRightArrow>`,
    upDownArrow: `<upDownArrow>
    <avLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <gd name="adj1" fmla="val 50000"/>
      <gd name="adj2" fmla="val 50000"/>
    </avLst>
    <gdLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <gd name="maxAdj2" fmla="*/ 50000 h ss"/>
      <gd name="a1" fmla="pin 0 adj1 100000"/>
      <gd name="a2" fmla="pin 0 adj2 maxAdj2"/>
      <gd name="y2" fmla="*/ ss a2 100000"/>
      <gd name="y3" fmla="+- b 0 y2"/>
      <gd name="dx1" fmla="*/ w a1 200000"/>
      <gd name="x1" fmla="+- hc 0 dx1"/>
      <gd name="x2" fmla="+- hc dx1 0"/>
      <gd name="dy1" fmla="*/ x1 y2 wd2"/>
      <gd name="y1" fmla="+- y2 0 dy1"/>
      <gd name="y4" fmla="+- y3 dy1 0"/>
    </gdLst>
    <ahLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <ahXY gdRefX="adj1" minX="0" maxX="100000">
        <pos x="x1" y="y3"/>
      </ahXY>
      <ahXY gdRefY="adj2" minY="0" maxY="maxAdj2">
        <pos x="l" y="y2"/>
      </ahXY>
    </ahLst>
    <cxnLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <cxn ang="3cd4">
        <pos x="hc" y="t"/>
      </cxn>
      <cxn ang="cd2">
        <pos x="l" y="y2"/>
      </cxn>
      <cxn ang="cd2">
        <pos x="x1" y="vc"/>
      </cxn>
      <cxn ang="cd2">
        <pos x="l" y="y3"/>
      </cxn>
      <cxn ang="cd4">
        <pos x="hc" y="b"/>
      </cxn>
      <cxn ang="0">
        <pos x="r" y="y3"/>
      </cxn>
      <cxn ang="0">
        <pos x="x2" y="vc"/>
      </cxn>
      <cxn ang="0">
        <pos x="r" y="y2"/>
      </cxn>
    </cxnLst>
    <rect l="x1" t="y1" r="x2" b="y4" xmlns="http://schemas.openxmlformats.org/drawingml/2006/main"/>
    <pathLst xmlns="http://schemas.openxmlformats.org/drawingml/2006/main">
      <path>
        <moveTo>
          <pt x="l" y="y2"/>
        </moveTo>
        <lnTo>
          <pt x="hc" y="t"/>
        </lnTo>
        <lnTo>
          <pt x="r" y="y2"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="y2"/>
        </lnTo>
        <lnTo>
          <pt x="x2" y="y3"/>
        </lnTo>
        <lnTo>
          <pt x="r" y="y3"/>
        </lnTo>
        <lnTo>
          <pt x="hc" y="b"/>
        </lnTo>
        <lnTo>
          <pt x="l" y="y3"/>
        </lnTo>
        <lnTo>
          <pt x="x1" y="y3"/>
        </lnTo>
        <lnTo>
          <pt x="x1" y="y2"/>
        </lnTo>
        <close/>
      </path>
    </pathLst>
  </upDownArrow>`,
  };
function U() {
  if (typeof DOMParser < 'u') return new DOMParser();
  throw new Error('DOMParser is not available. In Node.js install @xmldom/xmldom and assign global.DOMParser.');
}
function Y(t) {
  return t ? (t.charCodeAt(0) === 65279 ? t.slice(1) : t) : '';
}
var p = 'http://schemas.openxmlformats.org/drawingml/2006/main';
function m(t) {
  return Number.isNaN(t) || !Number.isFinite(t) ? 0 : t;
}
function B(t) {
  return typeof t == 'string' && /^-?\d+(?:\.\d+)?$/.test(t.trim());
}
function g(t) {
  return (t / 6e4) * (Math.PI / 180);
}
function W(t) {
  return Math.round((t * 180 * 6e4) / Math.PI);
}
function y(t, n) {
  return Math.sqrt(t * t + n * n);
}
function q(t) {
  let n = [];
  if (!t || typeof t.length != 'number') return n;
  for (let o = 0; o < t.length; o += 1) {
    let L = typeof t.item == 'function' ? t.item(o) : t[o];
    L && n.push(L);
  }
  return n;
}
function h(t, n, o) {
  if (!t) return [];
  if (typeof t.getElementsByTagNameNS == 'function') return q(t.getElementsByTagNameNS(n ?? null, o));
  if (typeof t.getElementsByTagName == 'function') {
    let l = q(t.getElementsByTagName(o));
    if (l.length) return l;
  }
  let L = [],
    e = [t];
  for (; e.length; ) {
    let l = e.pop();
    if (!l) continue;
    let r = l.childNodes;
    if (!(!r || typeof r.length != 'number'))
      for (let i = r.length - 1; i >= 0; i -= 1) {
        let s = typeof r.item == 'function' ? r.item(i) : r[i];
        if (!s || s.nodeType !== 1) continue;
        let a = s,
          f = a.localName || a.nodeName || a.tagName || '',
          c = f.includes(':') ? f.split(':').pop() : f,
          A = !n || !a.namespaceURI || a.namespaceURI === n;
        c === o && A && L.push(a), e.push(a);
      }
  }
  return L;
}
function b(t) {
  let n = [],
    o = t?.childNodes;
  if (!o || typeof o.length != 'number') return n;
  for (let L = 0; L < o.length; L += 1) {
    let e = typeof o.item == 'function' ? o.item(L) : o[L];
    e && e.nodeType === 1 && n.push(e);
  }
  return n;
}
function H(t, n) {
  let o = Object.create(null),
    L = t,
    e = n;
  return (
    (o.w = L),
    (o.h = e),
    (o.l = 0),
    (o.t = 0),
    (o.r = L),
    (o.b = e),
    (o.hc = L / 2),
    (o.vc = e / 2),
    (o.ss = Math.min(L, e)),
    [2, 3, 4, 5, 6, 8, 10, 12, 16, 20, 24, 32, 36, 40, 48, 64, 72, 96].forEach((r) => {
      (o[`wd${r}`] = L / r), (o[`hd${r}`] = e / r);
    }),
    o
  );
}
function k(t, n) {
  if (t == null || t === '') return 0;
  if (typeof t == 'number') return t;
  if (/^-?\d+(\.\d+)?$/.test(t)) return Number(t);
  if (/^-?[0-9]*cd[0-9]+$/.test(t)) {
    let L = t.split('cd'),
      e = L[0] === '' || L[0] === '-' ? +`${L[0]}1` : Number(L[0]),
      l = Number(L[1]);
    return l ? (216e5 / l) * e : 0;
  }
  let o = n[t];
  return typeof o == 'number' ? o : 0;
}
function V(t, n) {
  let o = t.trim().split(/\s+/),
    L = o[0],
    e = o.slice(1).map((l) => k(l, n));
  switch (L) {
    case 'val':
      return m(e[0]);
    case '+-':
      return m(e[0] + e[1] - e[2]);
    case '*/':
      return e[2] === 0 ? 0 : m((e[0] * e[1]) / e[2]);
    case '+/':
      return e[2] === 0 ? 0 : m((e[0] + e[1]) / e[2]);
    case 'abs':
      return Math.abs(e[0]);
    case 'max':
      return Math.max(e[0], e[1]);
    case 'min':
      return Math.min(e[0], e[1]);
    case 'pin':
      return Math.min(Math.max(e[0], e[1]), e[2]);
    case 'mod':
      return m(Math.hypot(...e));
    case 'sin': {
      let l = e[0],
        r = g(e[1]);
      return m(l * Math.sin(r));
    }
    case 'cos': {
      let l = e[0],
        r = g(e[1]);
      return m(l * Math.cos(r));
    }
    case 'atan2':
      return m(Math.atan2(e[1], e[0]));
    case 'tan': {
      let l = e[0],
        r = g(e[1]);
      return m(l * Math.tan(r));
    }
    case 'at2': {
      let l = Math.atan2(e[1], e[0]);
      return W(l);
    }
    case 'sat2': {
      let l = e[0],
        r = e[1],
        i = e[2],
        s = y(r, i);
      return s === 0 ? 0 : m((l * i) / s);
    }
    case 'cat2': {
      let l = e[0],
        r = e[1],
        i = e[2],
        s = y(r, i);
      return s === 0 ? m(l) : m((l * r) / s);
    }
    case '?:':
      return e[0] >= 0 ? e[1] : e[2];
    case 'sqrt':
      return e[0] < 0 ? 0 : Math.sqrt(e[0]);
    default:
      return (
        typeof console < 'u' &&
          process?.env?.NODE_ENV !== 'production' &&
          console.warn(`Unsupported formula operator "${L}"`),
        0
      );
  }
}
function z(t, n) {
  let o = h(t, p, 'avLst')[0];
  if (o) {
    let e = h(o, p, 'gd');
    for (let l of e) {
      let r = l.getAttribute('name'),
        i = l.getAttribute('fmla');
      !r || !i || (n[r] = V(i, n));
    }
  }
  let L = h(t, p, 'gdLst')[0];
  if (L) {
    let e = h(L, p, 'gd');
    for (let l of e) {
      let r = l.getAttribute('name'),
        i = l.getAttribute('fmla');
      !r || !i || (n[r] = V(i, n));
    }
  }
}
var G = {
  darken: 'color-mix(in srgb, currentColor 60%, black)',
  darkenless: 'color-mix(in srgb, currentColor 80%, black)',
  lighten: 'color-mix(in srgb, currentColor 60%, white)',
  lightenless: 'color-mix(in srgb, currentColor 80%, white)',
  accent: 'var(--preset-accent, currentColor)',
  accentlight: 'color-mix(in srgb, currentColor 85%, white)',
};
function J(t) {
  if (t == null) return '#000000';
  let n = String(t).toLowerCase();
  return n === 'norm' || n === 'auto'
    ? '#000000'
    : n === 'none' || n === 'false' || n === 'transparent'
      ? 'none'
      : n in G
        ? G[n]
        : /^#|^rgb|^hsl|^var\(/i.test(t)
          ? t
          : '#000000';
}
function R(t) {
  if (t == null) return '#000000';
  let n = t.toLowerCase();
  return n === 'none' || n === 'false' ? 'none' : /^#|^rgb|^hsl|^var\(/i.test(t) ? t : '#000000';
}
function Z(t, n, o, L) {
  let e = t.getAttribute('x'),
    l = t.getAttribute('y'),
    r = k(e, n),
    i = k(l, n);
  return o && B(e) && (r *= o), L && B(l) && (i *= L), { x: r, y: i };
}
function f0(t, n, o, L, e) {
  let l = n.getAttribute('wR'),
    r = n.getAttribute('hR'),
    i = Math.abs(k(l, o)),
    s = Math.abs(k(r, o));
  L && B(l) && (i *= L), e && B(r) && (s *= e);
  let a = k(n.getAttribute('stAng'), o),
    f = k(n.getAttribute('swAng'), o),
    c = ((a % 216e5) + 216e5) % 216e5,
    A = f;
  A <= -216e5 && (A = -216e5), A >= 216e5 && (A = 216e5);
  let x = g(c),
    d = 0,
    u = 0,
    M = 0,
    w = 0;
  t
    ? ((d = t.x), (u = t.y), (M = d - i * Math.cos(x)), (w = u - s * Math.sin(x)))
    : ((M = o.hc || 0), (w = o.vc || 0), (d = M + i * Math.cos(x)), (u = w + s * Math.sin(x)));
  let P = Math.max(1, Math.ceil(Math.abs(A) / 108e5)),
    C = A / P,
    N = [],
    T = c,
    E = d,
    D = u;
  for (let O = 0; O < P; O += 1) {
    let $ = T + C,
      I = g($),
      Q = M + i * Math.cos(I),
      j = w + s * Math.sin(I),
      s0 = Math.abs(C) > 108e5 ? 1 : 0,
      a0 = C >= 0 ? 1 : 0;
    N.push(`A ${i} ${s} 0 ${s0} ${a0} ${Q} ${j}`), (T = $), (E = Q), (D = j);
  }
  return { command: N.join(' '), startPoint: { x: d, y: u }, endPoint: { x: E, y: D } };
}
function e0(t, n) {
  if (t == null) return 1;
  let o = Number(t);
  return !Number.isFinite(o) || o === 0 ? 1 : n / o;
}
function t0(t, n, o, L) {
  let e = [],
    l = null,
    r = 0,
    i = !1,
    s = !1,
    a = e0(t.getAttribute('w'), o),
    f = e0(t.getAttribute('h'), L);
  for (let c of b(t)) {
    let A = c.localName || c.nodeName || '';
    switch (A.includes(':') ? A.split(':').pop() : A) {
      case 'moveTo': {
        let d = h(c, p, 'pt')[0];
        if (!d) break;
        let u = Z(d, n, a, f);
        e.push(`M ${u.x} ${u.y}`), (l = u), (r += 1);
        break;
      }
      case 'lnTo': {
        let d = h(c, p, 'pt')[0];
        if (!d) break;
        let u = Z(d, n, a, f);
        e.push(`L ${u.x} ${u.y}`), (l = u);
        break;
      }
      case 'quadBezTo': {
        let d = h(c, p, 'pt');
        if (d.length === 2) {
          let u = Z(d[0], n, a, f),
            M = Z(d[1], n, a, f);
          e.push(`Q ${u.x} ${u.y} ${M.x} ${M.y}`), (l = M);
        }
        break;
      }
      case 'cubicBezTo': {
        let d = h(c, p, 'pt');
        if (d.length === 3) {
          let u = Z(d[0], n, a, f),
            M = Z(d[1], n, a, f),
            w = Z(d[2], n, a, f);
          e.push(`C ${u.x} ${u.y} ${M.x} ${M.y} ${w.x} ${w.y}`), (l = w);
        }
        break;
      }
      case 'arcTo': {
        let { command: d, startPoint: u, endPoint: M } = f0(l, c, n, a, f);
        !l && u && (e.push(`M ${u.x} ${u.y}`), (r += 1)), e.push(d), (l = M), (s = !0);
        break;
      }
      case 'close':
        e.push('Z'), (l = null), (i = !0);
        break;
      default:
        break;
    }
  }
  return { d: e.join(' '), moveCount: r, isClosed: i, hasArc: s };
}
var c0 = new Set(['pathLst', 'avLst', 'gdLst', 'ahLst', 'cxnLst', 'rect']),
  n0 = 100,
  o0 = { width: n0, height: n0 },
  u0 = (t) => h(t, p, 'path').length > 0;
function p0(t) {
  let n = b(t);
  return u0(t) &&
    !n.some((e) => {
      let l = e.localName ?? e.tagName;
      return !c0.has(l);
    })
    ? [t]
    : n;
}
function A0(t, n, o, L) {
  let e = t.getAttribute('fill'),
    l = t.getAttribute('stroke'),
    r = l != null ? String(l).toLowerCase() : null,
    i = t.getAttribute('strokeWidth'),
    s = t.hasAttribute('fill'),
    a = t.hasAttribute('stroke'),
    f = R(l),
    c = s ? J(e) : void 0;
  s ||
    (o.isClosed
      ? a && (f === 'none' || f == null)
        ? (c = r === 'false' ? (L === 'arc' ? 'none' : 'currentColor') : 'none')
        : (c = '#000000')
      : (c = 'none')),
    !a && (c === '#000000' || c === 'none') && (f = R(null));
  let A;
  if ((i && (A = k(i, n)), (c === 'none' || c == null) && (f === 'none' || f == null))) return null;
  let x,
    d = t.getAttribute('fillRule') || t.getAttribute('fill-rule');
  return (
    d ? (x = d) : c !== 'none' && o.moveCount > 1 && (x = 'evenodd'),
    c === 'currentColor' && (c = '#000000'),
    { fill: c, stroke: f, strokeWidth: A, fillRule: x, clipRule: x }
  );
}
function h0(t, n, o) {
  let L = H(n, o);
  z(t, L);
  let e = h(t, p, 'pathLst')[0];
  if (!e) return null;
  let l = [],
    r = t.localName ?? t.tagName ?? 'shape';
  for (let i of h(e, p, 'path')) {
    let s = t0(i, L, n, o);
    if (!s || !s.d) continue;
    let a = A0(i, L, s, r);
    a && l.push({ d: s.d, ...a });
  }
  return l.length ? { name: r, viewBox: `0 0 ${n} ${o}`, paths: l } : null;
}
function L0(t, n = {}) {
  let o = n.width ?? o0.width,
    L = n.height ?? o0.height,
    e = U(),
    l = Y(t),
    i = e.parseFromString(l, 'application/xml').documentElement,
    s = [];
  for (let a of p0(i)) {
    if (a.nodeType !== 1) continue;
    let f = h0(a, o, L);
    f && s.push(f);
  }
  return s;
}
var M0 = ['fill', 'stroke', 'strokeWidth', 'fillRule', 'clipRule'],
  r0 = _;
function S(t) {
  if (!t) return null;
  let n = {};
  return (
    M0.forEach((o) => {
      let L = t[o];
      if (L !== void 0)
        if (o === 'strokeWidth') {
          if (typeof L == 'number') n.strokeWidth = L;
          else if (typeof L == 'string') {
            let e = Number(L);
            Number.isFinite(e) && (n.strokeWidth = e);
          }
        } else typeof L == 'string' && (n[o] = L);
    }),
    Object.keys(n).length ? n : null
  );
}
function l0(t, n) {
  let o = t.map((e) => ({ ...e }));
  if (!n) return o;
  let L = (e, l) => (typeof n == 'function' ? S(n(e, l)) : Array.isArray(n) ? S(n[l]) : S(n));
  return o.map((e, l) => {
    let r = L(e, l);
    return r ? { ...e, ...r } : e;
  });
}
function m0() {
  return Object.keys(r0);
}
function x0(t, n, o) {
  let L = X[t];
  if (!L) return null;
  let e = `<presetRoot xmlns:a="${p}">${L}</presetRoot>`,
    [l] = L0(e, { width: n, height: o });
  return l ? { viewBox: l.viewBox, paths: l.paths } : null;
}
function i0(t) {
  let { preset: n, styleOverrides: o, width: L, height: e } = t;
  if (!n) throw new Error('createPresetShape requires a preset name.');
  if (F.has(n) && L != null && e != null && L !== e) {
    let i = x0(n, L, e);
    if (i) return { preset: n, viewBox: i.viewBox, paths: l0(i.paths, o) };
  }
  let r = r0[n];
  if (!r) throw new Error(`Unknown preset shape: ${n}`);
  return { preset: n, viewBox: r.viewBox, paths: l0(r.paths, o) };
}
function k0(t) {
  let n = i0(t),
    o = n.paths.map((L) => {
      let e = [`d="${L.d}"`];
      return (
        L.fill !== void 0 && e.push(`fill="${L.fill}"`),
        L.stroke !== void 0 && e.push(`stroke="${L.stroke}"`),
        L.strokeWidth !== void 0 && e.push(`stroke-width="${L.strokeWidth}"`),
        L.fillRule !== void 0 && e.push(`fill-rule="${L.fillRule}"`),
        L.clipRule !== void 0 && e.push(`clip-rule="${L.clipRule}"`),
        `  <path ${e.join(' ')} />`
      );
    }).join(`
`);
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${n.viewBox}" preserveAspectRatio="none">
${o}
</svg>`;
}
export { i0 as createPresetShape, k0 as getPresetShapeSvg, m0 as listPresetNames };
//# sourceMappingURL=index.js.map
